<template>
    <div>
        <el-card style="margin-bottom: 5px;border: none;box-shadow: none;"
            :class="showCard.contract ? 'show_card' : 'show_card header-border'">
            <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="changeShow('contract')">
                <span style="font-weight: bold;font-size: 14px;color: #636569">合同相关信息解释</span>
                <i class="el-icon-arrow-up" v-show="showCard.contract"
                    style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开执行流程介绍">折叠</i>
                <i class="el-icon-arrow-down" v-show="!showCard.contract"
                    style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠执行流程介绍">展开</i>
            </div>
            <el-descriptions v-show="showCard.contract" style="margin-bottom: 0;font-size: 13px!important;" border :column="3">
                <el-descriptions-item label="合同编号规则">
                    <table class="tableCss">
                        <tr>
                            <th style="width: 120px;">预付款合同</th>
                            <td>以BZP开头，例BZP20240101000001</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">正式合同</th>
                            <td>以BZF开头，例BZF20240101000002</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">扣款合同</th>
                            <td>以BZD开头，例BZD20240101000003</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">执行合同</th>
                            <td>以BZ20开头，例BZ20240101000004</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">研发合同</th>
                            <td>以BZR开头，例BZR20240101000005</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">预付款转移合同</th>
                            <td>以BZT开头，例BZT20240101000006</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">结题报告合同</th>
                            <td>以BZB开头，例BZB20240101000007</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">团队费用合同</th>
                            <td>以BZS开头，例BZS20240101000007</td>
                        </tr>
                    </table>
                </el-descriptions-item>
                <el-descriptions-item label=" 各阶段状态">
                    <table class="tableCss">
                        <tr>
                            <th style="width: 120px;">合同审核</th>
                            <td>待审核/已通过/已驳回/已终止
                                <span style="color: #40a9ff;margin-left: 15px;cursor: pointer"
                                    @click="handleInfo('合同审核')">
                                    <i v-html="viewDetailIcon"></i>查看详情
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">扣款状态</th>
                            <td>未扣款/已扣款
                                <span style="color: #40a9ff;margin-left: 15px;cursor: pointer"
                                    @click="handleInfo('扣款状态')">
                                    <i v-html="viewDetailIcon"></i>查看详情
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">资料邮寄/扫描</th>
                            <td>未申请/已提交/已邮寄/已取消
                                <span style="color: #40a9ff;margin-left: 15px;cursor: pointer"
                                    @click="handleInfo('资料邮寄/扫描')">
                                    <i v-html="viewDetailIcon"></i>查看详情
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">发票开具</th>
                            <td>未申请/未开票/部分开票/全部开票
                                <span style="color: #40a9ff;margin-left: 15px;cursor: pointer"
                                    @click="handleInfo('发票开具')">
                                    <i v-html="viewDetailIcon"></i>查看详情
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">项目到款</th>
                            <td>未开票/未到款/部分到款/已到款
                                <span style="color: #40a9ff;margin-left: 15px;cursor: pointer"
                                    @click="handleInfo('项目到款')">
                                    <i v-html="viewDetailIcon"></i>查看详情
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">管理系统收样</th>
                            <td>未收样/已收样
                                <span style="color: #40a9ff;margin-left: 15px;cursor: pointer"
                                    @click="handleInfo('管理系统收样')">
                                    <i v-html="viewDetailIcon"></i>查看详情
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">原始数据</th>
                            <td>NA/未释放/部分释放/已释放
                                <span style="color: #40a9ff;margin-left: 15px;cursor: pointer"
                                    @click="handleInfo('原始数据')">
                                    <i v-html="viewDetailIcon"></i>查看详情
                                </span>
                            </td>
                        </tr>
                    </table>
                </el-descriptions-item>
                <el-descriptions-item label="合并规则">
                    <table class="tableCss">
                        <tr>
                            <th style="width: 120px;">合并邮寄</th>
                            <td>同一个销售 + 同一个客户</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">合并开票</th>
                            <td>同一个销售 + 合同可开票金额大于零 + 合并金额全部开票 + 合同全部审核通过</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">合并释放原始数据</th>
                            <td>同一个销售 + 同一个客户</td>
                        </tr>
                    </table>
                </el-descriptions-item>
                <el-descriptions-item label="系统自动审批" :span="3">
                    <table class="tableCss">
                        <tr>
                            <th style="width: 120px;">合同变更审批</th>
                            <td style="color: #f40a0a;width: 120px;">时间:实时审批</td>
                            <td>自动通过条件：合同是正式<->扣款，项目类型没有增加减少，存在的项目样品数量没有变化，或者有变化但是单价不变</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">合同终止审批</th>
                            <td style="color: #f40a0a;width: 120px;">时间:实时审批</td>
                            <td>合同类型必须为裸测/纯分析/测序分析，项目模块不包括硬盘购买和其他；自动通过条件： 如果实验未收样，自动审批</td>
                        </tr>
                    </table>
                </el-descriptions-item>
                <el-descriptions-item label="流程说明">
                    <table class="tableCss">
                        <tr>
                            <th style="width: 120px;">合同编辑</th>
                            <td>合同没有被审核，合同可以任意编辑；编辑时项目管理系统已存在的项目不能删除
                                <a @click="handleShowChart('edit')"><i class="el-icon-data-analysis"></i>查看流程</a>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">管理员编辑</th>
                            <td>合同审核通过且当前角色为管理员;已完全开票合同无法修改合同金额；合同可编辑的内容为甲方项目联系人、合同金额、合同分类、合同类型、增值金额、返样信息、项目信息；编辑时项目管理系统已存在的项目不能删除
                                <a @click="handleShowChart('adminEdit')"><i class="el-icon-data-analysis"></i>查看流程</a><br>
                                <span
                                    style="color: #f40a0a">若合同金额修改为0，该合同自动设置已开票已到款</span>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">{{ '合同变更' }}</th>
                            <td>
                                {{
                                    '合同存在原始数据释放审批提交或者已释放，裸测无法变更为测序分析;'
                                }}
                                <br>
                                {{
                                    '合同被审核且申请发票未通过审批，或者开具的所有发票都被退票，合同可以申请变更；变更时项目管理系统存在且上机测序的项目不能删除；'
                                }}
                                <br>
                                预付款扣款合同：变更的时候会检查管理系统是否释放了原始数据，如果释放了，不允许变更为正式合同；
                                <span style="color: #f40a0a">如已开票需要变更合同测序分析<->裸测，更改合同金额等,请联系程燕;价格/数量不变时，合同裸测不可变更为测序分析</span>
                                <a @click="handleShowChart('change')"><i class="el-icon-data-analysis"></i>查看流程</a>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">合同终止</th>
                            <td>
                                合同未开发票或者申请发票未通过审批或者所开发票都退票；注意：管理系统内已收样的合同不能直接终止
                                <a @click="handleShowChart('terminate')"><i class="el-icon-data-analysis"></i>查看流程</a>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">实验终止</th>
                            <td>
                                合同未开发票或者申请发票未通过审批或者所开发票都退票；注意：管理系统内已收样的合同只能实验终止，实验终止可以修改项目金额、合同金额
                                <a @click="handleShowChart('terminate')"><i class="el-icon-data-analysis"></i>查看流程</a>
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">发票邮寄安排</th>
                            <td>合同申请开票的时候同时申请邮寄时，只有开票申请被通过后，邮寄安排才会到”邮寄/扫描信息“内等待安排处理</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">合同发票邮寄安排</th>
                            <td>
                                申请合同+申请开票的时候同时申请邮寄时，只有合同+开票申请被通过后，邮寄安排才会到”邮寄/扫描信息“内等待安排处理
                            </td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">创建时间</th>
                            <td>系统创建合同时自动生成,当合同进行变更或编辑操作会自动更新为该操作成功时的时间</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">合同是否变更</th>
                            <td>若合同发生过变更，状态栏步骤条成功步骤的颜色为<span style="color: #f37963;">红色</span>；若未发生过变更，步骤条成功步骤的颜色为<span
                                    style="color:  #00FF00;">绿色</span></td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">干冰取消安排</th>
                            <td>当前账号角色为销售助理主管或管理员时，可取消干冰安排</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">合同签署</th>
                            <td style="color: #f40a0a;">申请合同签署成功后可申请释放分析结果；已质检通过后，且合同是未全部到款，才可申请合同签署;已申请签署并且到款/预付款扣款合同，系统自动撤销签署</td>
                        </tr>
                        <tr>
                            <th style="width: 120px;">预付款抵扣</th>
                            <td>正式合同部分开票且开票部分全部到款，可以申请抵扣扣款合同，直接扣除预付款</td>
                        </tr>
                    </table>
                </el-descriptions-item>
            </el-descriptions>
        </el-card>
        <el-card style="margin-bottom: 25px;border: none;box-shadow: none;"
            :class="showCard.weChat ? 'show_card' : 'show_card header-border'">
            <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="changeShow('weChat')">
                <span style="font-weight: bold;font-size: 14px;color: #636569">企微推送规则</span>
                <i class="el-icon-arrow-up" v-show="showCard.weChat"
                    style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开介绍">折叠</i>
                <i class="el-icon-arrow-down" v-show="!showCard.weChat"
                    style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠介绍">展开</i>
            </div>
            <el-descriptions v-show="showCard.weChat" style="margin-bottom: 0;font-size: 13px!important;" border :column="4">
                <el-descriptions-item label="销售推送">
                    <table class="tableCss">
                        <tr>
                            1、合同审核被驳回，企业微信推送给销售
                        </tr>
                        <tr>
                            2、合同签署发起成功后，签署链接推送销售
                        </tr>
                        <tr>
                            3、物料已邮寄，申请信息推送给销售
                        </tr>
                        <tr>
                            4、财务登记到款待认领信息后，广播推送给所有销售
                        </tr>
                        <tr>
                            5、干冰取消安排，企微推送给销售
                        </tr>
                        <tr>
                            6、发票退票审核通过
                        </tr>
                    </table>
                </el-descriptions-item>
                <el-descriptions-item label="销售助理推送">
                    <table class="tableCss">
                        <tr>
                            1、干冰安排，企业微信推送给邢金宇
                        </tr>
                    </table>
                </el-descriptions-item>
                <el-descriptions-item label="实验推送">
                    <table class="tableCss">
                       <tr>
                            1、单细胞项目上门，企业微信推送给实验室
                        </tr>
                       <tr>
                            2、保护剂邮寄，企业微信推送给实验室
                        </tr>
                        <tr>
                            3、商务系统如合同数据量变更并审批通过后,企微推送信息给龙欢:“xx合同xx项目数据量发生变更，请注意数据量变化”
                        </tr>
                    </table>
                </el-descriptions-item>
                <!-- <el-descriptions-item label="分析推送">
                    <table class="tableCss">
                        <tr>
                           1.销售提交纯分析评估后，企微推送给对应的评估人
                        </tr>
                    </table>
                </el-descriptions-item> -->
            </el-descriptions>
        </el-card>
        <el-tabs v-model="activeTab" @tab-click="changeActiveTab">
            <el-tab-pane label="草稿箱" name="draft"
                v-if="!['APPROVAL_SPECIALIST'].includes(role) && !evaluatorsFlag"></el-tab-pane>
            <el-tab-pane label="已提交" name="contract"></el-tab-pane>
            <el-tab-pane label="合同变更申请记录" name="change"></el-tab-pane>
            <el-tab-pane label="合同终止申请记录" name="terminate"></el-tab-pane>
            <el-tab-pane label="合同签署记录" name="sign"
                v-if="['MANAGER', 'ADMIN', 'SALES_ASSI', 'SALES_MANAGER', 'SALES', 'SALES_ASSI_MANAGER', 'APPROVAL_SPECIALIST'].includes(role) || evaluatorsFlag">
                <span slot="label" v-if="!['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'].includes(role) && !evaluatorsFlag">
                    <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="redNum.sign === 0 ? '' : redNum.sign"
                        :max="99">{{
                        '合同签署记录'
                        }}</el-badge>
                </span>
            </el-tab-pane>
        </el-tabs>
        <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;"
            v-if="!['APPROVAL_SPECIALIST'].includes(role) && !evaluatorsFlag"
            :class="{ 'disabled-status': ['APPROVAL_SPECIALIST'].includes(role) || evaluatorsFlag }">
            <div style="display: flex; align-items: center; flex-grow: 1;">
                <router-view></router-view>
                <el-button v-show="activeTab === 'draft'" size="small" type="success" icon="el-icon-plus"
                    @click="handleEdit()">添加</el-button>
                <el-button v-show="activeTab === 'draft'" size="small" type="danger" icon="el-icon-delete"
                    @click="handleDelete()">批量删除</el-button>
                <el-button v-show="activeTab === 'contract'" size="small" type="warning" icon="el-icon-s-promotion"
                    @click="promotionMail()">申请合并邮寄</el-button>
                <el-button v-show="activeTab === 'contract'" size="small" type="primary" icon="el-icon-s-ticket"
                    @click="contractAddRecord()">申请合并开票</el-button>
                <el-button v-show="activeTab === 'contract'" size="small" type="success" icon="el-icon-s-check"
                    v-if="['MANAGER', 'ADMIN', 'SALES_ASSI', 'SALES_MANAGER', 'SALES', 'SALES_ASSI_MANAGER'].includes(role)"
                    @click="signContract()">申请合并签署</el-button>
            </div>
            <export-components v-if="activeTab === 'contract'" :apiFunction="exportContract" :only-way="false" :ids="selectable.map(item => item.id)"
                :requestData="getSearch(terminateFlag ? { ...info.sendData } : { ...info.sendData, 'query#status.NE': 'DERELICT' }, activeTab)" :option="option"
                @sendData=getSearchData>
            </export-components>
        </div>
        <table-head-note></table-head-note>
        <table-col v-show="activeTab !== 'draft'" :cols="columns" :columnType="activeTab + 'TableCol5'"
            :table-col="columns" @submit="getCheckedBox"></table-col>
        <el-tabs v-model="activeName" @tab-click="changeActiveName" v-if="data[activeTab].children.length > 1">
            <el-tab-pane v-for="(tabInfo, tabIndex) in data[activeTab].children" :key="tabIndex" :label="tabInfo.label"
                :name="tabInfo.name">
                <span slot="label"
                    v-if="tabInfo.showBadge && !['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'].includes(role) && !evaluatorsFlag">
                    <el-badge style="margin-top: 10px;margin-bottom: 10px" :key="tabIndex"
                        :value="tabInfo.total === 0 ? '' : tabInfo.total" :max="99">{{
                        tabInfo.label
                        }}</el-badge>
                </span>
            </el-tab-pane>
        </el-tabs>
        <el-form v-if="activeTab === 'contract'">
            <el-form-item label="查看全部合同(默认不展示终止合同):">
                <el-switch @change="getData('', activeTab, activeName)" v-model="terminateFlag" active-color="#13ce66"
                    inactive-color="#ff4949"></el-switch>
            </el-form-item>
        </el-form>
        <w-table :columns="activeTab === 'draft' ? column : checkedCol" :table-data="tableData"
            @rowSelection="rowSelection($event, activeTab)" :openTableHeadNote="false" :key="info.name"
            @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event, activeTab, activeName) }"
            :isPagination="true" ref="wMyTable" :page="page"
            @pageChange="handlePagePagination($event, activeTab)" :isShowRowSelection="true">
            <template slot="otherCon"></template>
            <template slot="operation" slot-scope="{text,record}">
                <div v-if="['APPROVAL_SPECIALIST'].includes(role) || evaluatorsFlag">
                    <el-button
                        v-if="['contract', 'terminate', 'sign'].includes(activeTab) && record.contractType !== 'ADVANCE_PAYMENT_TRANSFER'"
                        size="mini" type="success" @click="handleDetails(record)">查看详情
                    </el-button>
                    <el-dropdown
                        v-if="activeTab === 'contract' && !['IMPORT_PREPAYMENTS'].includes(record.contractType) && !record['sourceIntentProjectId']"
                        @command="(command) => handleCommandContract(command, record)" size="small"
                        style="margin-left: 10px">
                        <el-button type="warning" size="mini">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="record.contractFilePath" icon="el-icon-download" command="download">
                                下载合同
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button v-if="activeTab === 'change'" size="mini" type="success"
                        @click="handleChangeDetails(record)">
                        查看详情
                    </el-button>
                </div>
                <div v-else>
                    <el-button v-if="record.contractType === 'ADVANCE_PAYMENT_TRANSFER'" size="mini" type="success"
                        @click="selectContract(record)">查询相关{{ record.projectType.slice(-2) }}合同</el-button>
                    <el-button
                        v-if="['contract', 'terminate', 'sign'].includes(activeTab) && record.contractType !== 'ADVANCE_PAYMENT_TRANSFER'"
                        size="mini" type="success" @click="handleDetails(record)">查看详情
                    </el-button>
                    <el-button
                        v-if="['sign'].includes(activeTab) && ['OPERATOR_READ', 'SIGN_FLOW_INITIATED'].includes(record.signStatus)"
                        size="mini" type="danger" @click="handleRevoke(record)">撤销签署
                    </el-button>
                    <el-dropdown
                        v-if="(record.signStatus === 'SIGNED' || !!record.annex) && ['sign'].includes(activeTab)"
                        @command="(command) => handleSignFile(command, record)" size="small" style="margin-left: 10px">
                        <el-button size="mini" type="primary">签署文件<i
                                class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item icon="el-icon-edit" command="show">查看</el-dropdown-item> -->
                            <el-dropdown-item icon="el-icon-download" command="download">下载</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="mini" type="primary"
                        v-if="activeTab === 'contract' && getEditStatus(record) && !['IMPORT_PREPAYMENTS', 'ADVANCE_PAYMENT_TRANSFER'].includes(record.contractType) && !record['sourceIntentProjectId'] && !['预付款抵扣正式合同尾款','预付款抵扣'].includes(record.projectType)"
                        @click="submit(record)">编辑
                    </el-button>
                    <el-dropdown
                        v-if="activeTab === 'contract' && record.status === 'SUCCESS' && ['ADMIN', 'MANAGER'].includes(role) && !['预付款抵扣正式合同尾款', '预付款抵扣'].includes(record.projectType)"
                        @command="(command) => handleAdmin(command, record)" size="small" style="margin-left: 10px">
                        <el-button type="primary" size="mini">管理员<i
                                class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                v-if="activeTab === 'contract' && record.status === 'SUCCESS' && ['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER'].includes(role) && ![ 'ADVANCE_PAYMENT_TRANSFER'].includes(record.contractType)"
                                icon="el-icon-edit" command="edit">管理员编辑
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="(['SUCCESS'].includes(record.status) && !['ADVANCE_PAYMENT_TRANSFER', 'DEVELOPMENT', 'IMPORT_PREPAYMENTS'].includes(record.contractType) && (!record['managementSystemData']['contractReceiptFlag'] || record.projectType.includes('纯分析'))) || (Number(record.contractAmount) === 0 && record.specificProjectType?.length > 0 && record.specificProjectType?.filter(item => item.projectStatus !== 'TERMINATION')?.length === 0)"
                                icon="el-icon-warning-outline" command="terminateContract">管理员终止合同
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="['SUCCESS'].includes(record.status) && !['ADVANCE_PAYMENT_TRANSFER', 'DEVELOPMENT', 'IMPORT_PREPAYMENTS'].includes(record.contractType)
                                    && record.specificProjectType?.filter(item => item.projectStatus !== 'TERMINATION')?.length > 0 && record['managementSystemData']['contractReceiptFlag']"
                                icon="el-icon-warning-outline" command="terminateProject">管理员终止实验
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="mini" type="primary" style="margin-left: 10px"
                        v-if="activeTab === 'contract' && record.status === 'SUCCESS' && ['ADMIN', 'SALES_MANAGER'].includes(role) && !['IMPORT_PREPAYMENTS', 'ADVANCE_PAYMENT_TRANSFER'].includes(record.contractType) && !record['sourceIntentProjectId'] && !['预付款抵扣正式合同尾款', '预付款抵扣'].includes(record.projectType)"
                        @click="adminEdits(record, 'salesManagerEdits')">销售经理编辑
                    </el-button>
                    <el-dropdown
                        v-if="activeTab === 'contract' && !['IMPORT_PREPAYMENTS'].includes(record.contractType) && !record['sourceIntentProjectId'] && !['预付款抵扣正式合同尾款', '预付款抵扣'].includes(record.projectType)"
                        @command="(command) => handleCommandContract(command, record)" size="small"
                        style="margin-left: 10px">
                        <el-button type="warning" size="mini">更多<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-s-ticket"
                                v-if="record.invoicedAmount > 0 && record.status === 'SUCCESS' && ['all', 'record'].includes(info.name)
                                    && !['CHARGEBACKS', 'DEVELOPMENT', 'ADVANCE_PAYMENT_TRANSFER', 'TEAM'].includes(record.contractType) && !(record['contractOffsetAuditFlag'] || record['offsetContractId'])"
                                command="record">申请开票
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="record.contractAmount === record.invoicedAmount && record.status === 'SUCCESS' && !['ADVANCE_PAYMENT_TRANSFER', 'TEAM'].includes(record.contractType)"
                                icon="el-icon-edit" command="complements">合同变更
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="['FORMAL'].includes(record.contractType) && ['PARTIAL_INVOICING'].includes(record.invoicingStatus) && ['MANAGER', 'ADMIN', 'SALES_ASSI', 'SALES_MANAGER', 'SALES', 'SALES_ASSI_MANAGER'].includes(role) && !record['offsetContractId']"
                                icon="el-icon-coin" command="offset">申请预付款抵扣
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="(((record.contractAmount === record.invoicedAmount && ['SUCCESS'].includes(record.status) && !['ADVANCE_PAYMENT_TRANSFER', 'DEVELOPMENT'].includes(record.contractType))
                                    || ['APPLYING', 'DEFEAT'].includes(record.status)) && (!record['managementSystemData']['contractReceiptFlag'] || record.projectType.includes('纯分析'))) 
                                    || (Number(record.contractAmount) === 0 && record.specificProjectType?.length > 0 &&  record.specificProjectType?.filter(item => item.projectStatus !== 'TERMINATION')?.length === 0)"
                                icon="el-icon-warning-outline" command="terminateContract">合同终止
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="(((record.contractAmount === record.invoicedAmount && ['SUCCESS'].includes(record.status) && !['ADVANCE_PAYMENT_TRANSFER', 'DEVELOPMENT'].includes(record.contractType))
                                    || ['APPLYING', 'DEFEAT'].includes(record.status))) && record.specificProjectType?.filter(item => item.projectStatus !== 'TERMINATION')?.length > 0 && record['managementSystemData']['contractReceiptFlag']"
                                icon="el-icon-warning-outline" command="terminateProject">实验终止
                            </el-dropdown-item>
                            <el-dropdown-item v-if="record.contractFilePath" icon="el-icon-download" command="download">
                                下载合同
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="record.status === 'SUCCESS'
                                    && (Object.keys(record.contractMails || {}).length === 0 || Object.values(record.contractMails || {}).filter(item => item !== 'CANCELED').length === 0)
                                    && ['all', 'file'].includes(info.name)
                                    && !record['contractTerminateAuditFlag']
                                    && !['ADVANCE_PAYMENT_TRANSFER', 'CHARGEBACKS', 'DEVELOPMENT', 'TEAM'].includes(record.contractType)"
                                icon="el-icon-s-promotion" command="promotionMail">申请资料邮寄/扫描
                            </el-dropdown-item>
                            <el-dropdown-item v-if="record.status === 'SUCCESS' && ['FORMAL'].includes(record.contractType)
                                && ['测序分析'].includes(record.projectType)
                                && ['MANAGER', 'ADMIN', 'SALES_ASSI', 'SALES_MANAGER', 'SALES', 'SALES_ASSI_MANAGER'].includes(role)
                                && record['contractRelatedStatus']['receiptStatus'] !== 'PAYMENT_RECEIVED'"
                                icon="el-icon-s-check" command="signContract">申请合同签署
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button v-if="activeTab === 'draft'" size="mini" type="success"
                        @click="handleEdit(record)">编辑</el-button>
                    <el-button v-if="activeTab === 'draft'" size="mini" type="danger"
                        @click="handleDelete(record)">删除</el-button>
                    <el-dropdown @command="handleCommand" style="margin-left: 10px" size="small"
                        v-if="activeTab === 'draft' && Object.values(record['annex']).some(value => value !== null && value !== '')">
                        <el-button size="mini" type="primary" color="#ffffff">下载</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="Object.keys(record['annex']['CONTRACT_ANNEX']).length > 0"
                                :command="{ command: 'CONTRACT_ANNEX', id: record.id, name: '' }">合同附件
                            </el-dropdown-item>
                            <el-dropdown-item v-if="Object.keys(record['annex']['LIST_OF_REAGENTS_ANNEX']).length > 0"
                                :command="{ command: 'LIST_OF_REAGENTS_ANNEX', id: record.id, name: '' }">试剂清单附件
                            </el-dropdown-item>
                            <el-dropdown-item v-if="Object.keys(record['annex']['REIMBURSEMENT_ANNEX']).length > 0"
                                :command="{ command: 'REIMBURSEMENT_ANNEX', id: record.id, name: 'completeAttachments' }">报账资料附件
                            </el-dropdown-item>
                            <el-dropdown-item v-if="Object.keys(record['annex']['MAIL_ANNEX']).length > 0"
                                :command="{ command: 'MAIL_ANNEX', id: record.id, name: 'completeAttachments' }">邮寄附件
                            </el-dropdown-item>
                            <el-dropdown-item v-if="Object.keys(record['annex']['REPORT_ANNEX']).length > 0"
                                :command="{ command: 'REPORT_ANNEX', id: record.id, name: 'completeAttachments' }">
                                结题报告附件
                            </el-dropdown-item>
                            <el-dropdown-item v-if="Object.keys(record['annex']['SENIOR_ANALYSIS_ANNEX']).length > 0"
                                :command="{ command: 'SENIOR_ANALYSIS_ANNEX', id: record.id, name: '' }">高级分析附件
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="Object.keys(record['annex']['CUSTOMIZED_ANALYSIS_ANNEX']).length > 0"
                                :command="{ command: 'CUSTOMIZED_ANALYSIS_ANNEX', id: record.id, name: '' }">个性化分析附件
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button v-if="activeTab === 'change'" size="mini" type="success"
                        @click="handleChangeDetails(record)">
                        查看详情
                    </el-button>
                </div>
            </template>
            <template slot="contractNumber" slot-scope="{text,record,index,column}">
                <div v-if="activeTab === 'sign'">
                    <ex-fold-table-cell v-if="record.sequencingContractDTO?.length > 0"
                        :scope="{ text: record.sequencingContractDTO.map(item => item.contractNumber), record, index }"></ex-fold-table-cell>
                </div>
                <div v-else>
                    <span>{{ text }}</span>
                    <el-tooltip content="复制">
                        <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
                    </el-tooltip>
                </div>
            </template>
            <template slot="signUrl" slot-scope="{text,record,index,column}">
                <div v-if="text && !record.annex">
                    <span>{{ text }}</span>
                    <el-tooltip content="复制">
                        <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
                    </el-tooltip>
                </div>
                <div v-else-if="record.annex">
                    NA
                </div>
            </template>
            <template slot="contractName" slot-scope="{text,record,index,column}">
                <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
            </template>
            <template slot="salesName" slot-scope="{record,index}">
                {{ record.sequencingContractDTO?.[0]?.sales?.name ?? '' }}
            </template>
            <template slot="contractMails" slot-scope="{text,record,recordIndex}">
                <div v-if="record.contractType !== 'ADVANCE_PAYMENT_TRANSFER'">
                    <div v-if="targetList.includes(record.projectType) && record.contractType === 'DEVELOPMENT'">
                        <ex-fold-mail type="request" :mails="protectiveFluidMail" :index="recordIndex"
                            :info="record['protectiveFluidMail']" :contract-id="record.id" @submit="refreshData"></ex-fold-mail>
                    </div>
                    <div v-else>
                        <ex-fold-mail type="mail" :mails="contractMails" :index="recordIndex" :info="text"
                            @submit="refreshData"></ex-fold-mail>
                    </div>
                </div>
                <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
            </template>
            <template slot="status" slot-scope="{text,record,index}">
                <branch-steps :data="getNodes(text, record)" :status-colors="getColor(record)"
                    :line-colors="getLineColor(record)" v-if="activeTab === 'contract'">
                    <template v-slot:create="{ node }">
                        <span>
                            <div style="display: flex">
                                <span>{{ '已创建' }}</span>
                            </div>
                           <div>
                                <span style="display: block; text-align: left;">时间：{{
                                    record.createTime }}</span>
                                <span style="display: block; text-align: left;">创建人：{{
                                    record.createBy }}</span>
                            </div>
                            <div v-if="record['contractChangeFlag']" style="color: #f37963 !important;">
                                <span style="display: block; text-align: left;">变更时间：{{
                                    record.contractChangeAuditInfo.changeTime }}</span>
                                <span style="display: block; text-align: left;">变更人：{{
                                    record.contractChangeAuditInfo.changer }}</span>
                            </div>
                        </span>
                    </template>
                    <template v-slot:audit="{ node }">
                        <span>
                            <div style="display: flex">
                                <span>{{status.find(item => item.label === text['contractAuditStatus'] && item.type
                                    ===
                                    'status')?.name}}</span>
                                <w-ellipsis-and-look style="margin-left:5px" class="w-ellipsis-and-look"
                                    :text="record['rejectionReason']" v-if="record.status === 'DEFEAT'"
                                    :column="{ title: '驳回原因' }" :onlyDetail="true" :isOpenHtml="false">
                                </w-ellipsis-and-look>
                            </div>
                            <div v-if="record.contractType === 'PREPAYMENTS'">
                               <span style="display: block; text-align: left;">增值金额：{{
                                    record.addedAmount }}</span>
                            </div>
                            <div
                                v-if="!['APPLYING', 'DERELICT'].includes(record.status) && record.contractType !== 'IMPORT_PREPAYMENTS'">
                                <span style="display: block; text-align: left;">时间：{{
                                    record.operatingTime }}</span>
                                <span style="display: block; text-align: left;">审核：{{
                                    record.operatingPersonName }}</span>
                            </div>
                            <div v-if="record.status === 'DERELICT' && record.contractType !== 'IMPORT_PREPAYMENTS'">
                                <div style="display: flex;">
                                    <span style="display: block; text-align: left;">时间：</span>
                                    <ex-fold-table-cell
                                        :scope="{ text: record['terminateAuditInfo']?.filter(item => item.status === 'SUCCESS').map(item => item.auditTime), record, index }"></ex-fold-table-cell>
                                </div>
                                <div style="display: flex;">
                                    <span style="display: block; text-align: left;">审核：</span>
                                    <ex-fold-table-cell
                                        :scope="{ text: record['terminateAuditInfo']?.filter(item => item.status === 'SUCCESS').map(item => item.operator), record, index }">
                                    </ex-fold-table-cell>
                                </div>
                            </div>
                           <div v-if="record['contractChangeFlag']" style="color: #f37963 !important;">
                                <span style="display: block; text-align: left;">变更审核时间：{{
                                    record.contractChangeAuditInfo.changeReviewTime }}</span>
                                <span style="display: block; text-align: left;">变更审核人：{{
                                    record.contractChangeAuditInfo.changeReviewer }}</span>
                            </div>
                        </span>
                    </template>
                    <template v-slot:protectiveMail="{ node }">
                        <div>
                            <div>
                                <div v-if="!getLatestProtectiveMail(record)">
                                    <span>待审核</span>
                                </div>
                                <div v-else-if="getLatestProtectiveMail(record).trackingFlag === -1">
                                    <span style="display: flex;">
                                        <span>已取消</span>
                                        <w-ellipsis-and-look style="margin-left:5px" class="w-ellipsis-and-look"
                                            :text="getLatestProtectiveMail(record).cancelReason"
                                            :column="{ title: '驳回原因' }" :onlyDetail="true" :isOpenHtml="false">
                                        </w-ellipsis-and-look>
                                    </span>
                                </div>
                                <div v-else>
                                    <span v-if="getLatestProtectiveMail(record).trackingFlag === 1"
                                        type="success">已邮寄</span>
                                    <span v-else-if="getLatestProtectiveMail(record).trackingFlag === 0"
                                        type="warning">待邮寄</span>
                                    <span v-else type="info">未知状态</span>
                                </div>
                            </div>
                            <div v-if="getLatestProtectiveMail(record)?.createTime">
                                <span style="display: block; text-align: left;">时间：{{
                                    getLatestProtectiveMail(record)?.createTime }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-slot:chargeback="{ node }">
                        <span>
                            <div style="display: flex">
                                <span v-if="record.contractType === 'TEAM'">{{ record.status === 'SUCCESS' ? '已到款' : '未到款' }}</span>
                                <span v-else>{{ stepNumber(text, record) > 1 ? '已扣款' : '未扣款' }}</span>
                            </div>
                           <div v-if="record.status === 'SUCCESS'">
                                <span style="display: block; text-align: left;">时间：{{
                                    record.operatingTime }}</span>
                                <span v-if="record.contractType !== 'TEAM'" style="display: block; text-align: left;">扣款人：{{
                                    record.operatingPersonName }}</span>
                                <span style="display: block; text-align: left;">{{ record.contractType === 'TEAM' ? '到款金额：' : '扣款金额：' }}{{
                                    record.contractAmount }}</span>
                            </div>
                        </span>
                    </template>
                    <template v-slot:receiptStatus="{ node }">
                        <span>
                            <div style="display: flex">
                                <span>{{ stepNumber(text, record) > 1 ? '已到账' : '未到账' }}</span>
                            </div>
                            <div v-if="record.status === 'SUCCESS'">
                                <span style="display: block; text-align: left;">时间：{{
                                    record.operatingTime }}</span>
                            </div>
                        </span>
                    </template>
                    <template v-slot:invoicing="{ node }">
                        <div>
                            <div>
                                <span v-if="record.offsetContractId">部分到款+尾款扣预付款</span>
                                <span v-else>{{status.find(item => item.label === text['invoicingStatus'] && item.type ===
                                    'invoice')?.name}}</span>
                            </div>
                            <div>
                                <span style="display: block; text-align: left;">可开票金额：
                                   {{ record.offsetContractId ? 0 : record?.invoicedAmount
                                    }}
                                </span>
                                <span style="display: block; text-align: left;">已申请开票金额：{{
                                    Number(record['contractAmount']) - Number(record['invoicedAmount'])
                                    }}
                                </span>
                                <span style="display: block; text-align: left;">已开票金额：{{
                                    record?.actualInvoicedAmount
                                }}
                                </span>
                            </div>
                            <div
                                v-if="text['invoicingStatus'] !== 'NOT_APPLYING' && record['invoiceRecordDTOs']?.filter(item => item.status !== 'APPLYING').length > 0">
                                <div style="display: flex;">
                                    <span style="display: block; text-align: left;">时间：</span>
                                    <ex-fold-table-cell
                                        :scope="{ text: record['invoiceRecordDTOs']?.filter(item => item.status === record.status).map(item => item.operatingTime), record, index }"></ex-fold-table-cell>
                                </div>
                                <div style="display: flex;">
                                    <span style="display: block; text-align: left;">审核：</span>
                                    <ex-fold-table-cell
                                        :scope="{ text: record['invoiceRecordDTOs']?.filter(item => item.status === record.status).map(item => item.operatingPersonName), record, index }">
                                    </ex-fold-table-cell>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:projectPayment="{ node }">
                        <span v-if="record.contractType === 'IMPORT_PREPAYMENTS' || record['sourceIntentProjectId']">{{
                            '已到款'
                            }}</span>
                        <span v-else>{{status.find(item => item.label === text['receiptStatus'] && item.type ===
                            'payment')?.name}}</span>
                        <div
                            v-if="!!record.receiptTime && ['PARTIAL_ARRIVAL', 'PAYMENT_RECEIVED'].includes(text['receiptStatus'])">
                            <span style="display: block; text-align: left;">时间：{{
                                record.receiptTime }}</span>
                        </div>
                    </template>
                    <template v-slot:returnSample="{ node }">
                        <span>{{status.find(item => item.label === record['returnSampleFlag'] && item.type ===
                            'returnSample')?.name}}</span>
                        <div
                            v-if="record['returnSampleFlag'] && record['returnCourierNumber']">
                            <span style="display: block; text-align: left;">快递单号：{{
                                record['returnCourierNumber'] }}</span>
                        </div>
                    </template>
                    <template v-slot:managementReceipt="{ node }">
                        <!-- <div>
                            <span
                                v-if="!(record.specificProjectType?.length > 0 && record.specificProjectType?.filter(item => item.projectStatus !== 'TERMINATION').length === 0)">
                                {{status.find(item => item.label ===
                                    record['managementSystemData']['contractReceiptFlag'] &&
                                    item.type === 'contractReceipt')?.name}}
                            </span>
                            <span v-else>
                                实验停止
                            </span>
                        </div> -->
                        <span>{{status.find(item => item.label ===
                            record['managementSystemData']['contractReceiptFlag'] &&
                            item.type === 'contractReceipt')?.name}}</span>
                        <div v-if="record?.['managementSystemData']?.['projectCollectingTime']">
                           <span style="display: block; text-align: left;">时间：{{
                                record?.['managementSystemData']?.['projectCollectingTime']
                                }}
                            </span>
                            <span style="display: block; text-align: left;">收样人：{{
                                record?.['managementSystemData']?.['projectCollector']
                            }}
                            </span>
                        </div>
                    </template>
                    <template v-slot:terminate="{ node }">
                        <span>已终止</span>
                        <div v-if="record?.terminateTime">
                            <span style="display: block; text-align: left;">
                                时间：{{ record?.terminateTime }}
                            </span>
                        </div>
                    </template>
                    <template v-slot:contractSign="{ node }">
                        <span v-if="['PAID'].includes(record.advancePaymentStatus)"> {{ '自流转(已垫付)' }} </span>
                        <span v-else-if="['CHARGEBACKS', 'DEVELOPMENT', 'TEAM'].includes(record.contractType)">
                            {{ record.status === 'SUCCESS' ? (record.contractType === 'TEAM' ? '自流转(已到款)' : '自流转(预付款扣款到款)') : 'NA' }}
                        </span>
                        <span v-else-if="record.contractType === 'FORMAL'">
                            <template v-if="record?.contractSignDTO?.signStatus">
                                {{status.find(item => item.label === record.contractSignDTO.signStatus &&
                                item.type
                                === 'sign')?.name || '未申请'}}
                            </template>
                            <template v-else>
                                {{ text['receiptStatus'] === 'PAYMENT_RECEIVED' ? '自流转(开票到款)' : '未申请' }}
                            </template>
                        </span>
                        <div
                            v-if="record?.['contractSignDTO']?.['signStatusDateMap']?.[record?.['contractSignDTO']?.['signStatus']]">
                            <span style="display: block; text-align: left;">时间：{{
                                record?.['contractSignDTO']?.['signStatusDateMap'][record['contractSignDTO']['signStatus']]
                                }}</span>
                        </div>
                    </template>
                    <template v-slot:uploadResult="{ node }">
                        <span>{{status.find(item => item.label ===
                            record['managementSystemData']['analyzeResultReleaseStatus'] &&
                            item.type === 'analyzeResult')?.name}}</span>
                        <div v-if="record?.['managementSystemData']?.['analyzeResultReleaseTime']">
                            <span style="display: block; text-align: left;">时间：{{
                                record?.['managementSystemData']?.['analyzeResultReleaseTime']
                                }}</span>
                               <span style="display: block; text-align: left;">分析员：{{
                                record?.['managementSystemData']?.['projectAnalyzer']
                            }}</span> 
                        </div>
                    </template>
                    <template v-slot:releaseResult="{ node }">
                        <span>{{status.find(item => item.label ===
                            (record['managementSystemData']?.['deliveryPlatformInfo']?.['releaseStatus'] ??
                            null) &&
                            item.type === 'release')?.name}}</span>
                        <div v-if="record?.['managementSystemData']?.['deliveryPlatformInfo']?.['releaseTime']">
                            <span style="display: block; text-align: left;">时间：{{
                                record?.['managementSystemData']?.['deliveryPlatformInfo']?.['releaseTime']
                                }}</span>
                        </div>
                    </template>
                    <template v-slot:rawData="{ node }">
                        <span>{{status.find(item => item.label ===
                            record['managementSystemData']['rawDataReleaseStatus'] && item.type ===
                            'rawDataRelease')?.name}}</span>
                        <div v-if="record?.['managementSystemData']?.['rawDataReleaseTime']">
                            <span style="display: block; text-align: left;">时间：{{
                                record?.['managementSystemData']?.['rawDataReleaseTime']
                                }}</span>
                        </div>
                    </template>
                </branch-steps>
                <div v-if="['change', 'terminate'].includes(activeTab)">
                    <span style="display: flex;align-items: center">
                        <el-tag :type="getStatusColor(text, 'tagType')"
                            :style="{ color: getStatusColor(text, 'color'), 'background-color': getStatusColor(text, 'backgroundColor') }">
                            {{ getStatusColor(text, 'name') }}</el-tag>
                        <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px"
                            class="w-ellipsis-and-look" :text="record['rejectionReason']" :column="{ title: '驳回原因' }"
                            :onlyDetail="true" :isOpenHtml="false">
                        </w-ellipsis-and-look>
                    </span>
                </div>
                <span style="display: flex;align-items: center" v-if="['sign'].includes(activeTab)">
                    <el-tag :type="getStatusColor(text, 'tagType')"
                        :style="{ color: getStatusColor(text, 'color'), 'background-color': getStatusColor(text, 'backgroundColor') }">
                        {{ getStatusColor(text, 'name') }}</el-tag>
                    <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
                        :text="record['rejectionReason']" :column="{ title: '驳回原因' }" :onlyDetail="true"
                        :isOpenHtml="false">
                    </w-ellipsis-and-look>
                </span>
            </template>
            <template slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='待审核'>待审核</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='已驳回'>已驳回</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='已通过'>已通过</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearchData(setSelectedKeys, selectedKeys, confirm, column, clearFilters, '', { tab: activeTab, name: activeName })">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
            <template slot="contractType" slot-scope="{text,record}">
                <div class="status-tag-container">
                    <el-tag :type="getContractColor(text, 'tagType')" :style="{
                        color: getContractColor(text, 'color'),
                        'background-color': getContractColor(text, 'backgroundColor'),
                        'border-color': getContractColor(text, 'borderColor')
                    }">{{
                        getContractColor(text, 'name') }}</el-tag>
                </div>
            </template>
            <template slot="impairmentFlag" slot-scope="{text,record}">
                <div class="status-tag-container" v-if="record.contractType !== 'ADVANCE_PAYMENT_TRANSFER'">
                    <el-tag v-if="text === 0" type="danger">否</el-tag>
                    <span v-else-if="text === 1" style="display: flex;align-items: center">
                        <el-tag type="success">是</el-tag>
                        <el-tooltip effect="dark" style="margin-left:5px" content="查看转预付款信息" placement="bottom">
                            <el-link type="primary" :underline="false" @click="showImpairment(record)"><i
                                    v-html="viewDetailIcon"></i></el-link>
                        </el-tooltip>
                    </span>
                </div>
                <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
            </template>
            <template slot="returnSampleFlag" slot-scope="{text,record}">
                <div class="status-tag-container"
                    v-if="['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(record.projectType) && record.contractType !== 'DEVELOPMENT'">
                    <el-tag v-if="text === false" type="danger">否</el-tag>
                    <el-tag v-else-if="text === true" type="success">是</el-tag>
                </div>
                <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
            </template>
            <template slot="contractChangeFlag" slot-scope="{text,record}">
                <div class="status-tag-container" v-if="record.contractType !== 'ADVANCE_PAYMENT_TRANSFER'">
                    <el-tag v-if="text" type="success">是</el-tag>
                    <el-tag v-else type="danger">否</el-tag>
                </div>
                <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
            </template>
            <template slot="executeContractNumber" slot-scope="{text,record}">
                <div v-if="text">
                    <span>{{ text }}</span>
                    <el-tooltip content="复制">
                        <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
                    </el-tooltip>
                </div>
                <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
            </template>
            <template slot="addedAmount" slot-scope="{text,record}">
                <div v-if="activeTab === 'contract'">
                    <span v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(record.contractType)">{{ text + '(' +
                        getProportion(record.contractAmount, record.addedAmount) + ')' }}</span>
                    <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
                </div>
                <div v-else-if="['change', 'terminate'].includes(activeTab)">
                    <span v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(record.data.contractType)">{{ text + '('
                        + getProportion(record.data.contractAmount, record.data.addedAmount) + ')'
                        }}</span>
                    <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
                </div>
                <div v-else-if="['sign'].includes(activeTab)">
                    <span
                        v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(record.sequencingContractDTO.contractType)">{{
                        text + '(' + getProportion(record.sequencingContractDTO.contractAmount,
                        record.sequencingContractDTO.addedAmount) + ')'
                        }}</span>
                    <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
                </div>
            </template>
            <template slot="invoicedAmount" slot-scope="{text,record}">
                <span
                    v-if="['PREPAYMENTS', 'FORMAL', 'IMPORT_PREPAYMENTS'].includes(record.contractType) && !record['sourceIntentProjectId']">{{
                    text }}</span>
                <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
            </template>
            <template slot="createSales" slot-scope="{record}">
                <span v-if="!(record?.initialSale?.uuid)">{{ 'NA' }}</span>
                <span v-else-if="record.initialSale.uuid === record.initialSalesId">{{ record.initialSale?.name ||
                    '系统内未找到'
                    }}</span>
                <div v-else>
                    <span style="display: block; text-align: left;">销售：{{
                        record.initialSale?.originalPersonMap?.[record.initialSalesId]?.['name'] || '系统内未找到'
                        }}(已离职)</span>
                    <span style="display: block; text-align: left;">离职时间：{{
                        record.initialSale?.originalPersonMap?.[record.initialSalesId]?.['deleteTime'] || '系统内未找到'
                        }}</span>
                </div>
            </template>
            <template slot="invoicingAmount" slot-scope="{text,record}">
                <span
                    v-if="['PREPAYMENTS', 'FORMAL', 'IMPORT_PREPAYMENTS'].includes(record.contractType) && !record['sourceIntentProjectId']">{{
                    Number(record['contractAmount']) - Number(record['invoicedAmount']) }}</span>
                <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
            </template>
            <template slot="signingPlace" slot-scope="{text,record}">
                <span v-if="!['ADVANCE_PAYMENT_TRANSFER'].includes(record.contractType)">{{
                    text }}</span>
                <el-tag type="info" v-else>{{ 'NA' }}</el-tag>
            </template>
            <template slot="contact" slot-scope="{text,record}">
                <el-tooltip effect="dark" content="查看客户信息" placement="bottom" v-if="text">
                    <el-link type="primary" :underline="false" @click="showContact(record)"><i
                            v-html="viewDetailIcon"></i></el-link>
                </el-tooltip>
                <span>{{ text }}</span>
            </template>
            <template slot="filterContractType"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='预付款'>预付款</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='正式'>正式</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='扣款'>扣款</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='老系统预付款'>老系统预付款</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='研发'>研发</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='预付款转移'>预付款转移</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='团队费用'>团队费用</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearchData(setSelectedKeys, selectedKeys, confirm, column, clearFilters, '', { tab: activeTab, name: activeName })">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
            <template slot="filterFlag" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='是'>是</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='否'>否</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearchData(setSelectedKeys, selectedKeys, confirm, column, clearFilters, '', { tab: activeTab, name: activeName })">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
            <template slot="filterContractStatus"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 0 15px;margin-bottom: 15px">
                    <el-radio-group v-model="selectedKeys[0]" size="small">
                        <el-radio-button v-for="item in statusOption" :key="item.value" :label="item.value">{{
                            item.label
                            }}</el-radio-button>
                    </el-radio-group>
                </div>
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-if="selectedKeys[0] === 'rawDataReleaseStatus'" v-model="selectedKeys[1]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='未释放'>未释放</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='部分释放'>部分释放</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='已释放'>已释放</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                    <el-radio-group v-if="selectedKeys[0] === 'status'" v-model="selectedKeys[1]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='待审核'>待审核</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='已驳回'>已驳回</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='已通过'>已通过</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='已终止'>已终止</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                    <el-radio-group v-if="selectedKeys[0] === 'invoicingStatus'" v-model="selectedKeys[1]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='未申请'>未申请</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='未开票'>未开票</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='部分开票'>部分开票</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='全部开票'>全部开票</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                    <el-radio-group v-if="selectedKeys[0] === 'returnSampleFlag'" v-model="selectedKeys[1]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='未返样'>未返样</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='已返样'>已返样</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearchData(setSelectedKeys, selectedKeys, confirm, column, clearFilters, 'contractRelatedStatus', { tab: activeTab, name: activeName }, statusOption)">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px"
                        @click="() => handleReset(column, clearFilters)">取消</a-button>
                </div>
            </template>
            <template slot="signStatus" slot-scope="{text,record,index}">
                <span style="display: flex;align-items: center" v-if="activeTab === 'sign'">
                    <el-tag :type="getSignColor(text, 'tagType')"
                        :style="{ color: getSignColor(text, 'color'), 'background-color': getSignColor(text, 'backgroundColor') }"><i
                            :class="getSignColor(text, 'icon')"></i>
                        {{ getSignColor(text, 'name') + (text === 'SIGNED' ? (!record.annex ? '(线上)':'(线下)') : '')
                        }}</el-tag>
                    <w-ellipsis-and-look v-if="text === 'VISA_REFUSAL'" style="margin-left:5px"
                        class="w-ellipsis-and-look" :text="record['resultDescription']" :column="{ title: '拒签原因' }"
                        :onlyDetail="true" :isOpenHtml="false">
                    </w-ellipsis-and-look>
                    <w-ellipsis-and-look v-if="text === 'INITIATION_FAILED'" style="margin-left:5px"
                        class="w-ellipsis-and-look" :text="record['failReason']" :column="{ title: '签署发起失败原因' }"
                        :onlyDetail="true" :isOpenHtml="false">
                    </w-ellipsis-and-look>
                </span>
                <div v-if="activeTab === 'contract'">
                    <ex-fold-sign :text="text" :index="index"
                        v-if="['FORMAL'].includes(record.contractType)"></ex-fold-sign>
                    <el-tag v-else type="info">NA</el-tag>
                </div>
            </template>
            <template slot="advancePaymentStatus" slot-scope="{text,record}">
                <div style="display: flex;align-items: center;justify-content: center;">
                    <el-tag :type="getAdvanceColor(text, 'tagType')" v-if="['FORMAL','PREPAYMENTS'].includes(record.contractType)"
                        :style="{ color: getAdvanceColor(text, 'color'), 'background-color': getAdvanceColor(text, 'backgroundColor') }">
                        {{ getAdvanceColor(text, 'name') }}</el-tag>
                    <el-tag type="info" v-else>NA</el-tag>
                </div>
            </template>

            <template slot="filterSignStatus"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='甲方已读'>甲方已读</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='签署发起成功'>签署发起成功</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">

                            <el-col :span="12">
                                <el-radio label='签署完成'>签署完成</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='拒签'>拒签</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='签署发起失败'>签署发起失败</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='已撤销'>已撤销</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearchData(setSelectedKeys, selectedKeys, confirm, column, clearFilters, '', { tab: activeTab, name: activeName })">搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
        </w-table>
        <picture-loading v-if="loading"></picture-loading>
        <contract-details v-if="details.showDialog" :show-dialog="details.showDialog" :select-detail="details.selectDetail"
            :info="details.info" @submit="(event) => close('details', event)">
        </contract-details>
        <contract-change-detail v-if="changeInfo.showDialog" :show-dialog="changeInfo.showDialog" :select-detail="changeInfo.selectDetail"
            @submit="(event) => close('changeInfo', event)">
        </contract-change-detail>
        <add-edit-c-r-m v-if="addEditCon.showDialog" :show-dialog="addEditCon.showDialog"
            :operation="addEditCon.operation" :select-detail="addEditCon.contractSelectDetail" :invoice-select-detail="addEditCon.invoiceSelectDetail"
            :mail-select-detail="addEditCon.mailSelectDetail" @submit="(event) => close('addEditCon', event)">
        </add-edit-c-r-m>
        <add-record-mail v-if="addEditInvoice.showDialog" :show-dialog="addEditInvoice.showDialog" :selectType="addEditInvoice.selectType"
            :contract-detail="addEditInvoice.contractDetails" :select-detail="addEditInvoice.selectDetail" @submit="(event) => close('addEditInvoice', event)">
        </add-record-mail>
        <add-edit-mail v-if="addEditMail.showDialog" :select-type="addEditMail.selectType" :show-dialog="addEditMail.showDialog"
            :select-detail="addEditMail.selectDetail" :contract-id="addEditMail.contractId" @submit="(event) => close('addEditMail', event)"></add-edit-mail>
        <status-info v-if="statusInfo.showDialog" :show-dialog="statusInfo.showDialog" :select-detail="statusInfo.selectDetail"
            @submit="(event) => close('statusInfo', event)"></status-info>
        <customer-user-info :show-dialog="contactInfo.showDialog" v-if="contactInfo.showDialog" :select-detail="contactInfo.selectDetail"
            @submit="(event) => close('contactInfo', event)"></customer-user-info>
        <impairment-info :show-dialog="impairmentInfo.showDialog" v-if="impairmentInfo.showDialog" :select-detail="impairmentInfo.selectDetail"
            @submit="(event) => close('impairmentInfo', event)"></impairment-info>
        <flow-chart v-if="flowChart.showDialog" :show-dialog="flowChart.showDialog" :select-detail="flowChart.selectDetail"
            @submit="(event) => close('flowChart', event)"></flow-chart>
        <add-terminate :select-detail="terminateData.selectDetail" :show-dialog="terminateData.showDialog" v-if="terminateData.showDialog"
            :type="terminateData.type" :flag="terminateData.flag" @submit="(event) => close('terminateData', event)"></add-terminate>
        <add-sign-contract :show-dialog="signContractInfo.showDialog" v-if="signContractInfo.showDialog" :contract-detail="signContractInfo.selectDetail"
            @submit="(event) => close('signContractInfo', event)"></add-sign-contract>
        <!-- 申请预付款抵扣弹窗 -->
        <add-off-set :show-dialog="offSet.showDialog" v-if="offSet.showDialog" :select-detail="offSet.selectDetail"
            @submit="(event) => close('offSet', event)"></add-off-set>
    </div>
</template>

<script>

import { draftContract } from "@/utils/data/tableCol/sales/draftContract";
import { exportContract, getContractPage, terminateApply, adminTerminate, getReceivedAmount } from "@/api/dilivery/sales/contract";
import { salesContract } from "@/utils/data/tableCol/sales/salesContract";
import { getDataInLocalStorage, saveDataToLocalStorage } from "@/utils/localStorage";
import { deleteDraft, getDraftPage } from "@/api/dilivery/draft";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import AddEditMail from "@/components/mail/AddEditMail.vue";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import AddEditCRM from "@/components/sales/AddEditCRM.vue";
import { tableOperationMixin } from "@/mixins/tableOperation";
import AddRecordMail from "@/components/record/AddRecordMail.vue";
import TableCol from "@/components/customerTable/TableCol.vue";
import { viewDetailIcon } from "@/utils/icon";
import { getMailPage } from "@/api/dilivery/mail";
import Template from "@/views/systems/Template/Template.vue";
import StatusInfo from "@/components/sales/StatusInfo.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import ExportComponents from "@/components/ExportComponents.vue";
import { getRecordPage } from "@/api/dilivery/record";
import { ContractChangeAudit } from "@/utils/data/tableCol/audit/ContractChange/ContractChangeAudit";
import { getAuditPage } from "@/api/dilivery/audit";
import ContractChangeDetail from "@/components/sales/ContractChangeDetail.vue";
import ExFoldMail from "@/components/ExFoldMail.vue";
import ExFoldSign from "@/components/ExFoldSign.vue";
import _ from 'lodash';
import { TerminateApplyAudit } from "@/utils/data/tableCol/audit/TerminateApplyAudit/TerminateApplyAudit";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import { copyText } from "@/utils/windowsUtils";
import { getContractColor, getStatusColor, getSignColor, getAdvanceColor } from "@/color"
import ImpairmentInfo from "@/components/impairment/ImpairmentInfo.vue";
import FlowChart from "@/components/flowChart/FlowChart.vue";
import { terminate } from "@/utils/data/flowChart/contract/terminate";
import { change } from "@/utils/data/flowChart/contract/change";
import { edit } from "@/utils/data/flowChart/contract/edit";
import { adminEdit } from "@/utils/data/flowChart/contract/adminEdit";
import { getDownloadLink, revokeSign } from "@/api/dilivery/sign";
import { getContractSignPage } from "../../../api/dilivery/sign";
import { ContractSign } from "../../../utils/data/tableCol/audit/ContractSign/ContractSign";
import AddTerminate from "@/components/terminate/AddTerminate.vue";
import AddSignContract from "@/components/sales/AddSignContract.vue";
import AddOffSet from "@/components/audit/offSet/AddOffSet.vue";
import BranchSteps from "@/components/step/BranchSteps.vue"
import { getProportion } from "@/utils/float_decimal";

const baseURL = process.env.VUE_APP_BASE_API
export default {
    name: "copySalesContract",
    components: {
        FlowChart, BranchSteps,
        ImpairmentInfo,
        CustomerUserInfo, AddTerminate,
        ExFoldMail, ExFoldSign, AddSignContract,
        AddOffSet,
        ContractChangeDetail, ExportComponents, PictureLoading, StatusInfo, Template,
        TableCol, AddRecordMail, AddEditCRM,
        ExFoldTableCell, ExFoldTable, ContractDetails, AddEditMail, TableHeadNote
    },
    mixins: [tableOperationMixin],
    data() {
        return {
            statusOption: [
                { label: '合同审核', value: 'status' },
                { label: '发票开票', value: 'invoicingStatus' },
                // {label:'项目到款',value:'payment'},
                { label: '原始数据', value: 'rawDataReleaseStatus' },
                { label: '返样状态', value: 'returnSampleFlag' },
            ],
            targetList: [
                "单细胞保护液",
                "微生态保护剂",
                "微生态保护液",
                "肠道菌群检测样本采集套装（16s全长）",
                "肠道菌群检测样本采集套装（宏基因组）",
                "RNA保护剂"
            ],
            contractMails: [
                { type: 'warning', value: 'NOT_MAILED', name: '不邮寄' },
                { type: 'primary', value: 'SUBMITTED', name: '已提交' },
                { type: 'success', value: 'MAILED', name: '已邮寄' },
                { type: 'danger', value: 'CANCELED', name: '已取消' },
            ],
            protectiveFluidMail: [
                { type: 'primary', value: 1, name: '待邮寄' },
                { type: 'success', value: 2, name: '已邮寄' },
                { type: 'danger', value: 0, name: '已取消' },
            ],
            status: [
                { label: 'SUCCESS', type: 'status', name: '已通过' },
                { label: 'APPLYING', type: 'status', name: '待审核' },
                { label: 'EVALUATING', type: 'status', name: '待评估' },
                { label: 'DEFEAT', type: 'status', name: '已驳回' },
                { label: 'DERELICT', type: 'status', name: '已终止' },

                { label: 'NOT_APPLYING', type: 'mail', name: '未申请' },
                { label: 'TO_BE_REVIEWED', type: 'mail', name: '待审核' },
                { label: 'REJECTED', type: 'mail', name: '已驳回' },
                { label: 'PASSED', type: 'mail', name: '待邮寄' },
                { label: 'SUBMITTED', type: 'mail', name: '已提交' },
                { label: 'MAILED', type: 'mail', name: '已邮寄' },
                { label: 'CANCELED', type: 'mail', name: '已取消' },

                { label: 'NOT_APPLYING', type: 'invoice', name: '未申请' },
                { label: 'NOT_INVOICED', type: 'invoice', name: '未开票' },
                { label: 'PARTIAL_INVOICING', type: 'invoice', name: '部分开票' },
                { label: 'ALL_INVOICED', type: 'invoice', name: '全部开票' },

                { label: 'NOT_RECEIVED', type: 'payment', name: '未到款' },
                { label: 'PARTIAL_ARRIVAL', type: 'payment', name: '部分到款' },
                { label: 'PAYMENT_RECEIVED', type: 'payment', name: '已到款' },
                { label: 'NOT_INVOICED', type: 'payment', name: '未开票' },

                { label: 'NOT_RELEASED', type: 'rawDataRelease', name: '未释放' },
                { label: 'PARTIAL_RELEASE', type: 'rawDataRelease', name: '部分释放' },
                { label: 'ALL_RELEASE', type: 'rawDataRelease', name: '已释放' },
                { label: null, type: 'rawDataRelease', name: 'NA' },

                { label: false, type: 'contractReceipt', name: '未收样' },
                { label: true, type: 'contractReceipt', name: '已收样' },

                { label: 'NOT_RELEASED', type: 'analyzeResult', name: '未上传' },
                { label: 'PARTIAL_RELEASE', type: 'analyzeResult', name: '部分上传' },
                { label: 'ALL_RELEASE', type: 'analyzeResult', name: '已上传' },
                { label: null, type: 'analyzeResult', name: '未上传' },

                { label: 'NOT_APPLYING', type: 'sign', name: '未申请' },
                { label: 'INITIATION', type: 'sign', name: '签署发起中' },
                { label: 'APPLY', type: 'sign', name: '待审核' },
                { label: 'REJECTED', type: 'sign', name: '已驳回' },
                { label: 'SIGN_FLOW_INITIATED', type: 'sign', name: '签署已发起' },
                { label: 'OPERATOR_READ', type: 'sign', name: '甲方已读' },
                { label: 'SIGNED', type: 'sign', name: '甲方已签' },
                { label: 'RETRACTED', type: 'sign', name: '已撤销' },
                { label: 'EXPIRED', type: 'sign', name: '已过期' },
                { label: 'INITIATION_FAILED', type: 'sign', name: '签署发起失败' },
                { label: 'VISA_REFUSAL', type: 'sign', name: '甲方拒签' },
                { label: 'AUTO', type: 'sign', name: '自流转' },

                { label: 'NOT_RELEASED', type: 'release', name: '未释放' },
                { label: 'PARTIAL_RELEASE', type: 'release', name: '部分释放' },
                { label: 'ALL_RELEASE', type: 'release', name: '已释放' },
                { label: null, type: 'release', name: 'NA' },

                { label: false, type: 'returnSample', name: '未返样' },
                { label: true, type: 'returnSample', name: '已返样' },
            ],
            option: [
                { label: '合同审核时间', value: 'operatingTime' },
                { label: '合同拟定时间', value: 'contractDraftingDate' },
                { label: '创建时间', value: 'createTime' },
            ],

            data: {
                draft: {
                    label: '草稿箱',
                    name: 'draft',
                    showBadge: false,
                    ApiMethod: getDraftPage,
                    children: [
                        {
                            label: '草稿箱',
                            name: 'draft',
                            showBadge: false,
                            ids: [],
                            sendData: {},
                            total: null,
                        },
                    ]
                },
                contract: {
                    label: '已提交',
                    name: 'contract',
                    showBadge: false,
                    ApiMethod: getContractPage,
                    children: [
                        {
                            label: '全部合同',
                            name: 'all',
                            showBadge: false,
                            sendData: {},
                            total: null,
                        },
                        {
                            label: '待审核',
                            name: 'audit',
                            showBadge: true,
                            sendData: {
                                "query#status.EQ": "APPLYING"
                            },
                            total: null,
                        },
                        {
                            label: '待邮寄',
                            name: 'file',
                            showBadge: true,
                            sendData: {
                                "query#mailStatus.EQ": "NOT_APPLYING",
                                "query#status.EQ": "SUCCESS",
                                "query#contractType.IN": "PREPAYMENTS,FORMAL"
                            },
                            total: null,
                        },
                        {
                            label: '未开发票/部分开票',
                            name: 'record',
                            showBadge: true,
                            sendData: {
                                "contractInvoiceFlag": false,
                                "query#status.EQ": "SUCCESS",
                                "query#contractType.IN": "PREPAYMENTS,FORMAL",
                            },
                            total: null,
                        },
                        {
                            label: '未到款',
                            name: 'receipt',
                            showBadge: true,
                            sendData: {
                                "query#contractType.IN": "PREPAYMENTS,FORMAL",
                                "query#receiptStatus.EQ": "NOT_RECEIVED"
                            },
                            total: null,
                        },
                        {
                            label: '退回合同',
                            name: 'failure',
                            showBadge: true,
                            sendData: {
                                "query#status.EQ": "DEFEAT"
                            },
                            total: null,
                        },
                        {
                            label: '待签署',
                            name: 'signApply',
                            showBadge: true,
                            sendData: {
                                "signFlag": true
                            },
                            total: null,
                        },
                        {
                            label: '待收样',
                            name: 'sampleReceipt',
                            showBadge: true,
                            sendData: {
                                "pendingSampleFlag": true
                            },
                            total: null,
                        },
                    ]
                },
                change: {
                    label: '合同变更申请记录',
                    name: 'change',
                    showBadge: false,
                    ApiMethod: getAuditPage,
                    children: [
                        {
                            label: '全部',
                            name: 'ALL',
                            showBadge: false,
                            sendData: {},
                            total: null,
                        },
                        {
                            label: '待审批',
                            name: 'NEW',
                            showBadge: false,
                            sendData: {
                                "query#status.EQ": "APPLYING"
                            },
                            total: null,
                        },
                        {
                            label: '已通过',
                            name: 'SUCCESS',
                            showBadge: false,
                            sendData: {
                                "query#status.EQ": "SUCCESS"
                            },
                            total: null,
                        },
                        {
                            label: '已驳回',
                            name: 'DEFEAT',
                            showBadge: false,
                            sendData: {
                                "query#status.EQ": "DEFEAT"
                            },
                            total: null,
                        },
                    ]
                },
                terminate: {
                    label: '合同终止申请记录',
                    name: 'terminate',
                    showBadge: false,
                    ApiMethod: getAuditPage,
                    children: [
                        {
                            label: '全部',
                            name: 'All',
                            showBadge: false,
                            sendData: {},
                            total: null,
                        },
                        {
                            label: '待审批',
                            name: 'New',
                            showBadge: false,
                            sendData: {
                                "query#status.EQ": "APPLYING"
                            },
                            total: null,
                        },
                        {
                            label: '已通过',
                            name: 'Success',
                            showBadge: false,
                            sendData: {
                                "query#status.EQ": "SUCCESS"
                            },
                            total: null,
                        },
                        {
                            label: '已驳回',
                            name: 'Defeat',
                            showBadge: false,
                            sendData: {
                                "query#status.EQ": "DEFEAT"
                            },
                            total: null,
                        },
                    ]
                },
                sign: {
                    label: '合同签署记录',
                    name: 'sign',
                    showBadge: false,
                    ApiMethod: getContractSignPage,
                    children: [
                        {
                            label: '全部',
                            name: 'signALL',
                            showBadge: false,
                            sendData: {},
                            total: null,
                        },
                        {
                            label: '签署已发起',
                            name: 'SIGN_FLOW_INITIATED',
                            showBadge: true,
                            sendData: {
                                "query#signStatus.EQ": "SIGN_FLOW_INITIATED"
                            },
                            total: null,
                        },
                        {
                            label: '甲方已读',
                            name: 'OPERATOR_READ',
                            showBadge: true,
                            sendData: {
                                "query#signStatus.EQ": "OPERATOR_READ"
                            },
                            total: null,
                        },
                        {
                            label: '甲方已签',
                            name: 'SIGNED',
                            showBadge: false,
                            sendData: {
                                "query#signStatus.EQ": "SIGNED"
                            },
                            total: null,
                        },
                        {
                            label: '甲方拒签',
                            name: 'VISA_REFUSAL',
                            showBadge: true,
                            sendData: {
                                "query#signStatus.EQ": "VISA_REFUSAL"
                            },
                            total: null,
                        },
                    ]
                }
            },

            viewDetailIcon: viewDetailIcon,
            activeTab: 'draft',
            activeName: 'draft',
            checkedCol: [], //选中的列
            terminateFlag: false,
            loading: true,
            tableData: [],
            selectable: [],
            searchConditionTag: [],//搜索tag
            sortConditionTag: [],
            page: {
                pageSize: 10,
                currentNum: 1,
                total: null
            },

            flowChart: {
                showDialog: false,
                selectDetail: { nodes: [], edges: [] }
            },
            signContractInfo:{
                showDialog: false,
                selectDetail: []
            },
            offSet:{
                showDialog: false,
                selectDetail: {}
            },//控制申请预付款抵扣页面显示
            contactInfo:{
                showDialog: false,
                selectDetail: []
            },
            impairmentInfo: {
                showDialog: false,
                selectDetail: {}
            },
            changeInfo:{
                showDialog: false,
                selectDetail: {}
            },
            terminateData:{
                showDialog: false,
                selectDetail: {},
                type:'',
                flag:''
            },//控制合同终止页面显示
            statusInfo:{
                showDialog: false,
                selectDetail: ''
            },
            addEditCon:{
                showDialog:false,
                operation:'',
                contractSelectDetail:{},
                invoiceSelectDetail:{},
                mailSelectDetail:{}
            },//控制合同增加修改页面显示与隐藏
            addEditInvoice:{
                showDialog: false,
                selectType:{},
                contractDetails:[],
                selectDetail:{}
            },
            addEditMail:{
                showDialog: false,
                selectType: {},
                selectDetail: {},
                contractId: []
            },
            details:{
                showDialog: false,
                selectDetail: [],
                info:{}
            },
            showCard:{
                contract: true,
                weChat:false,
            },//控制卡片显示
        }
    },
    watch: {
    },
    computed: {
        column() {
            return JSON.parse(JSON.stringify(draftContract([] || {})))
        },
        columns() {
            let cols = []
            if (this.activeTab === 'contract') {
                cols = salesContract([] || {})
            } else if (this.activeTab === 'change') {
                cols = ContractChangeAudit([] || {})
            } else if (this.activeTab === 'terminate') {
                cols = TerminateApplyAudit([] || {})
            } else {
                cols = ContractSign([] || {})
            }
            return JSON.parse(JSON.stringify(cols))
        },
        info() {
            return this.data[this.activeTab].children.find(item => item.name === this.activeName)
        },
        terminate() {
            return JSON.parse(JSON.stringify(terminate()))
        },
        change() {
            return JSON.parse(JSON.stringify(change()))
        },
        edit() {
            return JSON.parse(JSON.stringify(edit()))
        },
        adminEdit() {
            return JSON.parse(JSON.stringify(adminEdit()))
        },
        redNum () {
            let num = {}
            for (let item in this.data) {
                if(this.data[item].showBadge) {
                    num[item] = this.data[item].children.reduce((total, current) => total + (current.showBadge ? parseInt(current.total) || 0 : 0), 0)
                }else {
                    num[item] = 0
                }
            }
            return num
        },
        evaluatorsFlag() {
            return ['FINANCE','AUDITOR'].includes(this.role)
        },
        userData() {
            return JSON.parse(getDataInLocalStorage('user'))
        },
        role() {
            return getDataInLocalStorage('role')
        }
    },
    beforeDestroy() {
        // 组件销毁前执行清理逻辑
        saveDataToLocalStorage('isShow', !!this.showCard.contract)
    },
    created() {
        if (['APPROVAL_SPECIALIST'].includes(this.role) || this.evaluatorsFlag) {
            this.activeTab = 'contract'
            this.activeName = 'all'
        }
        this.showCard.contract = getDataInLocalStorage('isShow') === 'true'
    },
    mounted() {
        this.getData('', this.activeTab, this.activeName)
    },
    methods: {
        getProportion,
        getAdvanceColor,
        getColor(record) {
            // 团队费用（TEAM）合同步骤条整体使用紫色
            if (record.contractType === 'TEAM') {
                return {
                    wait: '#c0c4cc',
                    process: '#303133',
                    finish: '#722ed1',
                    success: '#722ed1',
                    error: '#f56c6c',
                    half: '#b37feb',
                    finishText: '#722ed1',
                    successText: '#722ed1'
                }
            }
            if (record['contractChangeFlag']) {
                return {
                    wait: '#c0c4cc',
                    process: '#303133',
                    finish: '#f37963',
                    success: '#f37963',
                    error: '#f56c6c',
                    half:'#93ea74'
                }
            }
            return {
                wait: '#c0c4cc',
                process: '#303133',
                finish: '#67c23a',
                success: '#67c23a',
                error: '#f56c6c',
                half: '#93ea74'
            }
        },
        getLineColor(record) {
            // 团队费用（TEAM）合同步骤条连线整体使用紫色
            if (record.contractType === 'TEAM') {
                return {
                    wait: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#c0c4cc',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    process: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#c0c4cc',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    finish: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#722ed1',
                        success: '#722ed1',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    success: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#722ed1',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    error: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#c0c4cc',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    half: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#c0c4cc',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    }
                }
            }
            if (record['contractChangeFlag']) {
                return {
                    wait: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#c0c4cc',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    process: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#c0c4cc',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    finish: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#f37963',
                        success: '#f37963',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    success: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#f37963',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    error: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#c0c4cc',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    },
                    half: {
                        wait: '#c0c4cc',
                        process: '#c0c4cc',
                        finish: '#c0c4cc',
                        success: '#c0c4cc',
                        error: '#c0c4cc',
                        half: '#c0c4cc'
                    }
                }
            }
            return {
                wait: {
                    wait: '#c0c4cc',
                    process: '#c0c4cc',
                    finish: '#c0c4cc',
                    success: '#c0c4cc',
                    error: '#c0c4cc',
                    half: '#c0c4cc'
                },
                process: {
                    wait: '#c0c4cc',
                    process: '#c0c4cc',
                    finish: '#c0c4cc',
                    success: '#c0c4cc',
                    error: '#c0c4cc',
                    half: '#c0c4cc'
                },
                finish: {
                    wait: '#c0c4cc',
                    process: '#c0c4cc',
                    finish: '#67c23a',
                    success: '#67c23a',
                    error: '#c0c4cc',
                    half: '#c0c4cc'
                },
                success: {
                    wait: '#c0c4cc',
                    process: '#c0c4cc',
                    finish: '#67c23a',
                    success: '#c0c4cc',
                    error: '#c0c4cc',
                    half: '#c0c4cc'
                },
                error: {
                    wait: '#c0c4cc',
                    process: '#c0c4cc',
                    finish: '#c0c4cc',
                    success: '#c0c4cc',
                    error: '#c0c4cc',
                    half: '#c0c4cc'
                },
                half: {
                    wait: '#c0c4cc',
                    process: '#c0c4cc',
                    finish: '#c0c4cc',
                    success: '#c0c4cc',
                    error: '#c0c4cc',
                    half: '#c0c4cc'
                }
            }
        },
        //查询预付款转移合同
        selectContract(row) {
            this.searchConditionTag = this.searchConditionTag.filter(item => item.title !== '预付款转移相关合同')
            let data = {
                title: '预付款转移相关合同',
                key: 'contractNumber',
                value: row.contractNumber
            }
            this.searchConditionTag.push(data)
            this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
            this.getData('search', this.activeTab, this.activeName)
        },
        //撤销签署
        handleRevoke(row) {
            this.$confirmUi('是否撤销合同签署?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                revokeSign(row.id).then(res => {
                    if (res.code === 200) {
                        this.$messageUi.success('合同签署撤销成功')
                        this.getData('', this.activeTab, this.activeName)
                    } else {
                        this.$messageUi.error('合同签署撤销失败')
                    }
                }).catch(err => { })
            }).catch(() => { });
        },
        //合同签署文件
        async handleSignFile(command, row) {
            switch (command) {
                case 'download':
                    this.handleDownloadSign(row)
                    break;
                default:
                    break;
            }
        },
        //查看流程图
        handleShowChart(type) {
          this.flowChart = {
            showDialog: true,
            selectDetail: this[type]
          }
        },
        getStatusColor,
        getSignColor,
        getContractColor,
        exportContract,
        refreshData(type) {
            if (type === 'confirm') {
                this.getData('', this.activeTab, this.activeName)
            }
        },
        copyData(text) {
            copyText(text)
            this.$messageUi.success('复制成功')
        },
        showContact(row) {
            if (this.activeTab === 'contract') {
                this.contactInfo.selectDetail = [row.customerContacts]
            } else if (['change', 'terminate'].includes(this.activeTab)) {
                this.contactInfo.selectDetail = [row.data.customerContacts]
            } else {
                this.contactInfo.selectDetail = [row.sequencingContractDTO.customerContacts]
            }
            this.contactInfo.showDialog = true
        },
        showImpairment(row) {
            this.impairmentInfo = {
                showDialog: true,
                selectDetail: row
            }
        },
        returnStatus(text) {
            if (['DEFEAT','DERELICT'].includes(text)) {
                return 'error'
            } else {
                return ''
            }
        },
        getLatestProtectiveMail(record) {
            const mailList = record?.['protectiveFluidMail'];
            if (!mailList || !Array.isArray(mailList) || mailList.length === 0) return null;
            return mailList.reduce((latest, item) =>
                item.createTime > latest.createTime ? item : latest
            , mailList[0]);
        },
        handleInfo(type) {
            this.statusInfo = {
                showDialog: true,
                selectDetail: type
            }
        },
        stepNumber(row, record) {
            // 动态收集实际渲染的步骤
            const steps = [];

            // 预付款抵扣仅展示：合同创建、合同审核、扣款状态
            if (['预付款抵扣正式合同尾款','预付款抵扣'].includes(record.projectType)) {
                steps.push(() => true);
                steps.push(() =>
                    !['APPLYING', 'DEFEAT', 'EVALUATING', 'DERELICT', 'CONTRACT_TO_BE_SUBMITTED'].includes(row['contractAuditStatus'])
                );
                steps.push(() => record.status === 'SUCCESS');

                for (let i = 0; i < steps.length; i++) {
                    if (!steps[i]()) {
                        return i;
                    }
                }
                return steps.length;
            }

            // 1. 合同创建（所有类型都渲染）
            steps.push(() => true);

            // 2. 合同审核（所有类型都渲染）
            steps.push(() =>
                !['APPLYING', 'DEFEAT', 'EVALUATING', 'DERELICT', 'CONTRACT_TO_BE_SUBMITTED'].includes(row['contractAuditStatus'])
            );

            // 3. 物料邮寄（仅研发-微生态保护液）
            if (record.contractType === 'DEVELOPMENT' && this.targetList.includes(record.projectType)) {
                const latestMail = this.getLatestProtectiveMail(record);
                steps.push(() =>
                    latestMail &&
                    latestMail.trackingFlag === 1
                );
            }

            // 4. 扣款状态（仅扣款合同或转移合同扣款）
            if (record.contractType === 'CHARGEBACKS' || record.projectType === '转移合同扣款') {
                steps.push(() =>
                    record.status === 'SUCCESS'
                );
            }

            // 5. 收款状态（仅转移合同入账）
            if (record.projectType === '转移合同入账') {
                steps.push(() =>
                    record.status === 'SUCCESS'
                );
            }

            // 6. 发票开具（预付款、正式，且无 sourceIntentProjectId）
            if (
                ['PREPAYMENTS', 'FORMAL'].includes(record.contractType) &&
                !record['sourceIntentProjectId']
            ) {
                steps.push(() =>
                    row['invoicingStatus'] === 'ALL_INVOICED' || !!row['offsetContractId']
                );
            }

            // 7. 项目到款（预付款、正式、老系统预付款）
            if (
                ['PREPAYMENTS', 'FORMAL', 'IMPORT_PREPAYMENTS'].includes(record.contractType)
            ) {
                steps.push(() =>
                    row['receiptStatus'] === 'PAYMENT_RECEIVED'
                );
            }

            // 8. 管理系统收样（正式、扣款、研发，且不是某些特殊项目类型）
            if (
                ['FORMAL', 'CHARGEBACKS', 'DEVELOPMENT'].includes(record.contractType) &&
                !(
                    record.contractType === 'CHARGEBACKS' &&
                    [...this.targetList, '预付款扣款（其他）'].includes(record.projectType)
                ) &&
                !['数据库、服务器、系统流程开发和部署', '培训服务', ...this.targetList, '其他','预付款扣款（数据库、服务器、系统流程开发和部署）','预付款扣款（培训服务）'].includes(record.projectType)
            ) {
                steps.push(() =>
                    record['managementSystemData'] &&
                    record['managementSystemData']['contractReceiptFlag']
                );
            }
            // 9. 合同签署（正式，且测序分析/预付款扣款（测序分析））
            if (
                ['FORMAL', 'CHARGEBACKS', 'DEVELOPMENT'].includes(record.contractType) &&
                ['测序分析', '预付款扣款（测序分析）'].includes(record.projectType)
            ) {
                steps.push(() => {
                    if (record.contractType === 'FORMAL') {
                        if (record?.contractSignDTO?.signStatus) {
                            return record?.contractSignDTO?.signStatus === 'SIGNED'
                        }
                        return row['receiptStatus'] === 'PAYMENT_RECEIVED'
                    } else {
                        if (record.status !== 'SUCCESS') {
                            return false;
                        } else {
                            return true;
                        }
                    }
                }
                );
            }
            // 10. 上传分析结果（正式、扣款、研发，且测序分析/预付款扣款（测序分析））
            if (
                ['FORMAL', 'CHARGEBACKS', 'DEVELOPMENT'].includes(record.contractType) &&
                ['测序分析', '预付款扣款（测序分析）', '纯分析', '预付款扣款（纯分析）'].includes(record.projectType)
            ) {
                steps.push(() =>
                    record['managementSystemData'] &&
                    record['managementSystemData']['analyzeResultReleaseStatus'] === 'ALL_RELEASE'
                );
            }

            

            // // 11. 分析结果释放（正式、扣款、研发，且测序分析/预付款扣款（测序分析））
            if (
                ['FORMAL', 'CHARGEBACKS', 'DEVELOPMENT'].includes(record.contractType) &&
                ['测序分析', '预付款扣款（测序分析）', '纯分析', '预付款扣款（纯分析）'].includes(record.projectType)
            ) {
                steps.push(() =>
                    record['managementSystemData'] &&
                    record['managementSystemData']['deliveryPlatformInfo'] &&
                    record['managementSystemData']['deliveryPlatformInfo']['releaseStatus'] === 'ALL_RELEASE'
                );
            }

            // 12. 原始数据（正式、扣款、研发，且不是某些特殊项目类型）
            if (
                ['FORMAL', 'CHARGEBACKS', 'DEVELOPMENT'].includes(record.contractType) && record?.['managementSystemData']?.['hasRaw'] && 
                !(
                    record.contractType === 'CHARGEBACKS' &&
                    [...this.targetList, '预付款扣款（其他）'].includes(record.projectType)
                ) &&
                !['数据库、服务器、系统流程开发和部署', '培训服务', ...this.targetList, '其他', '纯分析', '预付款扣款（纯分析）', '预付款扣款（数据库、服务器、系统流程开发和部署）', '预付款扣款（培训服务）'].includes(record.projectType)
            ) {
                steps.push(() =>
                    record['managementSystemData'] &&
                    record['managementSystemData']['rawDataReleaseStatus'] === 'ALL_RELEASE'
                );
            }

            // 遍历steps，返回第一个未完成的步骤（active从1开始）
            for (let i = 0; i < steps.length; i++) {
                if (!steps[i]()) {
                    return i;
                }
            }
            // 全部完成则高亮最后一步
            return steps.length;
        },
    
        getNodes(row, record) {
            const r = { ...row };
            const rec = { ...record };

            if (['预付款抵扣正式合同尾款', '预付款抵扣'].includes(rec.projectType)) {
                const nodes = [
                    { id: 'create', label: '合同创建', status: 'success', previous: [], next: ['audit'],row: 0, column: 0 },
                    { id: 'audit', label: '合同审核', status: !['APPLYING', 'DEFEAT', 'EVALUATING', 'DERELICT', 'CONTRACT_TO_BE_SUBMITTED'].includes(r['contractAuditStatus']) ? 'finish' : (this.returnStatus(r['contractAuditStatus']) ?? 'wait'), previous: ['create'], next: ['chargeback'], row: 0, column: 1 },
                    { id: 'chargeback', label: '扣款状态', status: rec.status === 'SUCCESS' ? 'finish' : 'wait', previous: ['audit'], next: [] , row: 0, column: 2}
                ];
                return { nodes, columns: [0], rows: [0,1,2] };
            }

            // 团队费用（TEAM）合同：步骤条复用「预付款扣款（XXX）」扣款合同的节点结构，
            // 其中「扣款状态」节点替换为「到款」，审核通过（status=SUCCESS）即显示已到款
            const isTeam = rec.contractType === 'TEAM';
            if (isTeam && ['裸测', '测序分析', '纯分析'].includes(rec.projectType)) {
                rec.contractType = 'CHARGEBACKS';
                r.contractType = 'CHARGEBACKS';
                rec.projectType = '预付款扣款（' + rec.projectType + '）';
                r.projectType = rec.projectType;
            }

            if (r['contractAuditStatus'] === 'DERELICT') {
                const nodes = [
                    { id: 'create', label: '合同创建', status: 'success', previous: [], next: ['audit'], row: 0, column: 0 },
                    { id: 'audit', label: '合同审核', status: 'error', previous: ['create'], next: [], row: 0, column: 1 }
                ];
                return { nodes, columns: [0], rows: [0, 1] };
            }

            // 布尔标志
            const hasProtectiveMail = rec.contractType === 'DEVELOPMENT' && this.targetList.includes(rec.projectType);
            const hasChargeback = rec.contractType === 'CHARGEBACKS' || rec.projectType === '转移合同扣款';
            const hasReceipt = rec.projectType === '转移合同入账';
            const hasInvoicing = (['PREPAYMENTS', 'FORMAL'].includes(rec.contractType) && !rec['sourceIntentProjectId'] && Number(rec.contractAmount) !== 0);
            const hasPayment = (['PREPAYMENTS', 'FORMAL', 'IMPORT_PREPAYMENTS'].includes(rec.contractType) && Number(rec.contractAmount) !== 0);
            const hasReturnSample = ['返样/暂存样品','预付款扣款（返样/暂存样品）'].includes(rec.projectType);
            const hasManagementReceipt = ['FORMAL', 'CHARGEBACKS', 'DEVELOPMENT'].includes(rec.contractType) && !hasReturnSample
                && !(rec.contractType === 'CHARGEBACKS' && [...this.targetList, '预付款扣款（其他）'].includes(rec.projectType))
                && !['数据库、服务器、系统流程开发和部署', '培训服务', ...this.targetList, '其他', '预付款扣款（数据库、服务器、系统流程开发和部署）', '预付款扣款（培训服务）'].includes(rec.projectType);
            const hasTerminate = !!rec.terminateTime
            const hasSignBranch = ['FORMAL', 'CHARGEBACKS', 'DEVELOPMENT'].includes(rec.contractType) && !hasTerminate && !hasReturnSample
                && ['测序分析', '预付款扣款（测序分析）'].includes(rec.projectType) && rec?.['managementSystemData']?.['hasRaw'];
            const hasAnalyzeBranch = ['FORMAL', 'CHARGEBACKS', 'DEVELOPMENT'].includes(rec.contractType) && !hasTerminate && !hasReturnSample
                && ['测序分析', '预付款扣款（测序分析）', '纯分析', '预付款扣款（纯分析）'].includes(rec.projectType);
            const hasRawData = hasManagementReceipt && rec?.['managementSystemData']?.['hasRaw'] && !hasTerminate 
                && !['纯分析', '预付款扣款（纯分析）'].includes(rec.projectType);

            // 状态判断函数
            const isCreated = () => true;
            const isAudit = () => !['APPLYING', 'DEFEAT', 'EVALUATING', 'DERELICT', 'CONTRACT_TO_BE_SUBMITTED'].includes(r['contractAuditStatus']);
            const latestProtectiveMail = Array.isArray(rec['protectiveFluidMail']) && rec['protectiveFluidMail'].length > 0
                ? rec['protectiveFluidMail'].reduce((latest, item) => item.createTime > latest.createTime ? item : latest, rec['protectiveFluidMail'][0])
                : null;
            const isProtectiveMailDone = () => latestProtectiveMail && latestProtectiveMail.trackingFlag === 1;
            const isChargebackDone = () => rec.status === 'SUCCESS';
            const isReceiptDone = () => rec.status === 'SUCCESS';
            const isInvoicingDone = () => r['invoicingStatus'] === 'ALL_INVOICED' || !!rec['offsetContractId'];
            const isPaymentDone = () => r['receiptStatus'] === 'PAYMENT_RECEIVED';
            const isReturnSampleDone = () => !!rec['returnSampleFlag'];
            const isManagementReceiptDone = () => rec['managementSystemData'] && rec['managementSystemData']['contractReceiptFlag'];
            const isTerminateDone = () => true;
            const isContractSignDone = () => {
                if (['PAID'].includes(rec.advancePaymentStatus)) {
                    return true
                } else if (rec.contractType === 'FORMAL') {
                    if (rec?.contractSignDTO?.signStatus) {
                        return rec?.contractSignDTO?.signStatus === 'SIGNED';
                    }
                    return r['receiptStatus'] === 'PAYMENT_RECEIVED';
                } else {
                    return rec.status === 'SUCCESS';
                }
            };
            const isUploadResultDone = () => rec['managementSystemData'] && rec['managementSystemData']['analyzeResultReleaseStatus'] === 'ALL_RELEASE';
            const isReleaseResultDone = () => rec['managementSystemData'] && rec['managementSystemData']['deliveryPlatformInfo'] && rec['managementSystemData']['deliveryPlatformInfo']['releaseStatus'] === 'ALL_RELEASE';
            const isRawDataDone = () => rec['managementSystemData'] && rec['managementSystemData']['rawDataReleaseStatus'] === 'ALL_RELEASE';

            // 构造基础节点（顺序代表线性顺序）
            let nodes = [];
            nodes.push({ id: 'create', label: '合同创建', status: isCreated() ? 'success' : 'wait', previous: [], next: [] });
            const auditStatus = isAudit() ? 'success' : (this.returnStatus(r['contractAuditStatus'])??'wait');
            nodes.push({ id: 'audit', label: '合同审核', status: auditStatus, previous: [], next: [] });
            const mailStatus = isProtectiveMailDone() ? 'success' : (latestProtectiveMail?.trackingFlag === -1 ? 'error' : 'wait');
            if (hasProtectiveMail) nodes.push({ id: 'protectiveMail', label: '物料邮寄', status: mailStatus, previous: [], next: [] });
            if (hasChargeback) nodes.push({ id: 'chargeback', label: isTeam ? '到款' : '扣款状态', status: isChargebackDone() ? 'success' : 'wait', previous: [], next: [] });
 
            let invoicingStatus;
            if (isInvoicingDone()) {
                invoicingStatus = 'success';
            } else if (r['invoicingStatus'] === 'NOT_APPLYING') {
                invoicingStatus = 'wait';
            } else if (r['invoicingStatus'] === 'NOT_INVOICED') {
                invoicingStatus = 'process';
            } else if (r['invoicingStatus'] === 'PARTIAL_INVOICING') {
                invoicingStatus = 'half';
            } else {
                invoicingStatus = 'wait';
            }
            if (hasInvoicing) nodes.push({ id: 'invoicing', label: '发票开具', status: invoicingStatus, previous: [], next: [] });
            if (hasReceipt) nodes.push({ id: 'receiptStatus', label: '收款状态', status: isReceiptDone() ? 'success' : 'wait', previous: [], next: [] });
            let paymentStatus;
            if (isPaymentDone()) {
                paymentStatus = 'success';
            } else if (r['receiptStatus'] === 'PARTIAL_ARRIVAL') {
                paymentStatus = 'half';
            } else {
                paymentStatus = 'wait';
            }
            if (hasPayment) nodes.push({ id: 'projectPayment', label: '项目到款', status: paymentStatus, previous: [], next: [] });
            if (hasReturnSample) nodes.push({ id: 'returnSample', label: '返样状态', status: isReturnSampleDone() ? 'success' : 'wait', previous: [], next: [] });
            if (hasManagementReceipt) nodes.push({ id: 'managementReceipt', label: '管理系统收样', status: isManagementReceiptDone() ? 'success' : 'wait', previous: [], next: [] });

            if (hasTerminate) nodes.push({ id: 'terminate', label: '实验终止', status: isTerminateDone() ? 'error' : 'wait', previous: [], next: [] });
            if (hasSignBranch) {
                const flag = () => {
                    if (['CHARGEBACKS', 'DEVELOPMENT'].includes(rec.contractType)) {
                        return rec.status === 'SUCCESS';
                    } else if (rec.contractType === 'FORMAL') {
                        return (r['receiptStatus'] === 'PAYMENT_RECEIVED' && !rec?.contractSignDTO?.signStatus);
                    }
                    return false
                }
                
                const signStatus = flag() ? 'success' : (rec?.contractSignDTO?.signStatus === 'RETRACTED') ? 'error' : (isContractSignDone() ? 'success' : 'wait');
                nodes.push({ id: 'contractSign', label: '合同签署', status: signStatus, previous: [], next: [] });
            }
            if (hasAnalyzeBranch) {
                nodes.push({ id: 'uploadResult', label: '上传分析结果', status: isUploadResultDone() ? 'success' : 'wait', previous: [], next: [] });
                nodes.push({ id: 'releaseResult', label: '分析结果释放', status: isReleaseResultDone() ? 'success' : 'wait', previous: [], next: [] });
            }
            if (hasRawData) nodes.push({ id: 'rawData', label: '原始数据', status: isRawDataDone() ? 'success' : (record['managementSystemData']['rawDataReleaseStatus'] === 'PARTIAL_RELEASE' ? 'half' : 'wait'), previous: [], next: [] });

            // 分支节点只在同时存在 contractSign 和 analyzeBranch 时形成分支结构
            function populateNodeRelationships(nodes, hasSignBranch, hasAnalyzeBranch) {
                // 清空关系
                nodes.forEach(node => {
                    node.previous = [];
                    node.next = [];
                });

                const nodeOrder = [
                    'create', 'audit', 'protectiveMail', 'chargeback',
                    'invoicing', 'receiptStatus', 'projectPayment','returnSample', 'managementReceipt','terminate',
                    'contractSign', 'uploadResult', 'releaseResult', 'rawData'
                ];

                const existingNodeIds = nodes.map(n => n.id);
                const orderedExistingNodeIds = nodeOrder.filter(id => existingNodeIds.includes(id));

                const branchEntries = ['contractSign', 'uploadResult'];
                const mergeId = 'releaseResult';

                // 找到第一个分支入口在 orderedExistingNodeIds 中的位置，用其前一个节点作为分支入口的上游节点
                let firstBranchIndex = orderedExistingNodeIds.findIndex(id => branchEntries.includes(id));
                let lastNonBranchNodeId = null;
                if (firstBranchIndex > 0) {
                    lastNonBranchNodeId = orderedExistingNodeIds[firstBranchIndex - 1];
                } else {
                    // 兜底：如果没找到，则选择 audit 或第一个存在的非分支节点
                    lastNonBranchNodeId = orderedExistingNodeIds.find(id => !branchEntries.includes(id) && id !== mergeId) || orderedExistingNodeIds[0] || null;
                }
                const lastNonBranchNode = nodes.find(n => n.id === lastNonBranchNodeId);

                // 构建线性关系，跳过分支入口和合并点（分支单独处理）
                for (let i = 0; i < orderedExistingNodeIds.length - 1; i++) {
                    const cur = orderedExistingNodeIds[i];
                    const nxt = orderedExistingNodeIds[i + 1];

                    // 跳过分支入口与合并点之间的线性连接，后面单独处理
                    if (branchEntries.includes(cur) || branchEntries.includes(nxt) || cur === mergeId || nxt === mergeId) {
                        continue;
                    }
                    const curNode = nodes.find(n => n.id === cur);
                    const nextNode = nodes.find(n => n.id === nxt);
                    if (curNode && nextNode) {
                        if (!curNode.next.includes(nextNode.id)) curNode.next.push(nextNode.id);
                        if (!nextNode.previous.includes(curNode.id)) nextNode.previous.push(curNode.id);
                    }
                }

                // 处理分支与合并逻辑
                const signNode = nodes.find(n => n.id === 'contractSign');
                const uploadNode = nodes.find(n => n.id === 'uploadResult');
                const releaseNode = nodes.find(n => n.id === mergeId);
                const rawDataNode = nodes.find(n => n.id === 'rawData');

                if (hasSignBranch && hasAnalyzeBranch) {
                    // 上游指向两个分支入口
                    if (lastNonBranchNode) {
                        if (signNode && !lastNonBranchNode.next.includes(signNode.id)) lastNonBranchNode.next.push(signNode.id);
                        if (signNode && !signNode.previous.includes(lastNonBranchNode.id)) signNode.previous.push(lastNonBranchNode.id);

                        if (uploadNode && !lastNonBranchNode.next.includes(uploadNode.id)) lastNonBranchNode.next.push(uploadNode.id);
                        if (uploadNode && !uploadNode.previous.includes(lastNonBranchNode.id)) uploadNode.previous.push(lastNonBranchNode.id);
                    }

                    // 两条分支都指向 releaseResult（releaseResult 作为合并点）
                    if (releaseNode) {
                        if (signNode && !signNode.next.includes(releaseNode.id)) signNode.next.push(releaseNode.id);
                        if (uploadNode && !uploadNode.next.includes(releaseNode.id)) uploadNode.next.push(releaseNode.id);

                        if (signNode && !releaseNode.previous.includes(signNode.id)) releaseNode.previous.push(signNode.id);
                        if (uploadNode && !releaseNode.previous.includes(uploadNode.id)) releaseNode.previous.push(uploadNode.id);

                        // releaseResult 指向后续节点（如 rawData 或 orderedExistingNodeIds 中 release 后的第一个非分支节点）
                        if (rawDataNode) {
                            if (!releaseNode.next.includes(rawDataNode.id)) releaseNode.next.push(rawDataNode.id);
                            if (!rawDataNode.previous.includes(releaseNode.id)) rawDataNode.previous.push(releaseNode.id);
                        } else {
                            const releaseIdx = orderedExistingNodeIds.indexOf(mergeId);
                            if (releaseIdx !== -1) {
                                for (let j = releaseIdx + 1; j < orderedExistingNodeIds.length; j++) {
                                    const cand = orderedExistingNodeIds[j];
                                    if (!branchEntries.includes(cand) && cand !== mergeId) {
                                        const candNode = nodes.find(n => n.id === cand);
                                        if (candNode) {
                                            if (!releaseNode.next.includes(candNode.id)) releaseNode.next.push(candNode.id);
                                            if (!candNode.previous.includes(releaseNode.id)) candNode.previous.push(releaseNode.id);
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                    }
                } else if (hasSignBranch && !hasAnalyzeBranch) {
                    // 仅合同签署为分支，按线性处理：上游->contractSign->后续第一个非分支节点
                    if (lastNonBranchNode && signNode) {
                        if (!lastNonBranchNode.next.includes(signNode.id)) lastNonBranchNode.next.push(signNode.id);
                        if (!signNode.previous.includes(lastNonBranchNode.id)) signNode.previous.push(lastNonBranchNode.id);
                        const signIdx = orderedExistingNodeIds.indexOf('contractSign');
                        if (signIdx !== -1 && signIdx < orderedExistingNodeIds.length - 1) {
                            for (let j = signIdx + 1; j < orderedExistingNodeIds.length; j++) {
                                const cand = orderedExistingNodeIds[j];
                                if (cand !== 'contractSign') {
                                    const candNode = nodes.find(n => n.id === cand);
                                    if (candNode) {
                                        if (!signNode.next.includes(candNode.id)) signNode.next.push(candNode.id);
                                        if (!candNode.previous.includes(signNode.id)) candNode.previous.push(signNode.id);
                                    }
                                    break;
                                }
                            }
                        }
                    }
                } else if (!hasSignBranch && hasAnalyzeBranch) {
                    // 仅上传分析为分支，按线性处理：上游->uploadResult->后续第一个非分支节点（upload->release如果存在则保留）
                    if (lastNonBranchNode && uploadNode) {
                        if (!lastNonBranchNode.next.includes(uploadNode.id)) lastNonBranchNode.next.push(uploadNode.id);
                        if (!uploadNode.previous.includes(lastNonBranchNode.id)) uploadNode.previous.push(lastNonBranchNode.id);

                        // 如果存在 releaseNode（分析结果释放）且 uploadNode 存在，则 upload -> release
                        if (releaseNode) {
                            if (!uploadNode.next.includes(releaseNode.id)) uploadNode.next.push(releaseNode.id);
                            if (!releaseNode.previous.includes(uploadNode.id)) releaseNode.previous.push(uploadNode.id);

                            // release -> 后续节点
                            if (rawDataNode) {
                                if (!releaseNode.next.includes(rawDataNode.id)) releaseNode.next.push(rawDataNode.id);
                                if (!rawDataNode.previous.includes(releaseNode.id)) rawDataNode.previous.push(releaseNode.id);
                            } else {
                                const releaseIdx = orderedExistingNodeIds.indexOf(mergeId);
                                if (releaseIdx !== -1) {
                                    for (let j = releaseIdx + 1; j < orderedExistingNodeIds.length; j++) {
                                        const cand = orderedExistingNodeIds[j];
                                        if (cand !== mergeId) {
                                            const candNode = nodes.find(n => n.id === cand);
                                            if (candNode) {
                                                if (!releaseNode.next.includes(candNode.id)) releaseNode.next.push(candNode.id);
                                                if (!candNode.previous.includes(releaseNode.id)) candNode.previous.push(releaseNode.id);
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                        } else {
                            // 没有 releaseNode，upload 指向后续第一个非分支节点
                            const uploadIdx = orderedExistingNodeIds.indexOf('uploadResult');
                            if (uploadIdx !== -1 && uploadIdx < orderedExistingNodeIds.length - 1) {
                                for (let j = uploadIdx + 1; j < orderedExistingNodeIds.length; j++) {
                                    const cand = orderedExistingNodeIds[j];
                                    if (cand !== 'uploadResult') {
                                        const candNode = nodes.find(n => n.id === cand);
                                        if (candNode) {
                                            if (!uploadNode.next.includes(candNode.id)) uploadNode.next.push(candNode.id);
                                            if (!candNode.previous.includes(uploadNode.id)) candNode.previous.push(uploadNode.id);
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }

                // 若既无两条分支也无单分支（或分支处理后仍需补全线性连接），确保剩余线性连接完整
                for (let i = 0; i < orderedExistingNodeIds.length - 1; i++) {
                    const cur = orderedExistingNodeIds[i];
                    const nxt = orderedExistingNodeIds[i + 1];
                    const curNode = nodes.find(n => n.id === cur);
                    const nextNode = nodes.find(n => n.id === nxt);
                    if (!curNode || !nextNode) continue;

                    // 已在分支逻辑中处理的连接跳过
                    if (curNode.next.includes(nextNode.id) || nextNode.previous.includes(curNode.id)) continue;

                    // 若两节点都不是分支入口/合并点，添加线性连接
                    if (!branchEntries.includes(cur) && !branchEntries.includes(nxt) && cur !== mergeId && nxt !== mergeId) {
                        if (!curNode.next.includes(nextNode.id)) curNode.next.push(nextNode.id);
                        if (!nextNode.previous.includes(curNode.id)) nextNode.previous.push(curNode.id);
                    }
                }

                return nodes;
            }


            nodes = populateNodeRelationships(nodes, hasSignBranch, hasAnalyzeBranch)
            // 状态调整逻辑：
            const firstNotSuccessIdx = nodes.findIndex(n => !['finish', 'success'].includes(n.status));

            // 将第一个非 success/finish 之前的所有 success 状态节点改为 finish
            if (firstNotSuccessIdx > 0) {
                for (let i = 0; i < firstNotSuccessIdx; i++) {
                    if (nodes[i].status === 'success') {
                        nodes[i].status = 'finish';
                    }
                }
            }else{
                for (let i = 0; i < nodes.length; i++) {
                    if (nodes[i].status === 'success') {
                        nodes[i].status = 'finish';
                    }
                }
            }

            // 3) 对每个节点：若其所有 previous 都为 finish，且自身不是 success/finish/error，则设为 process；否则设为 wait（除 error 保持不变）
            for (const n of nodes) {
                if (n.status === 'error' || ['finish', 'success', 'half'].includes(n.status)) {
                    continue;
                }
                const prevs = n.previous || [];
                const allPrevFinish = prevs.length === 0
                    ? true
                    : prevs.every(pid => {
                        const pn = nodes.find(x => x.id === pid);
                        return pn && pn.status === 'finish';
                    });
                if (allPrevFinish) {
                    n.status = 'process';
                } else {
                    n.status = 'wait';
                }
            }

            // 清理临时标志（以防有旧逻辑残留）
            nodes.forEach(n => delete n._markedProcess);

            // 布局：如果存在分支结构（合同签署 + 上传分析结果同时存在且 managementReceipt 存在），进行列/行拓扑布局；否则线性布局（所有 row=0，column 顺序）
            let outNodes = nodes.map(n => ({ ...n })); // shallow copy
            let rows = [];
            let columns = [];

            const hasBranchStructure = (outNodes.some(n => n.id === 'contractSign') && outNodes.some(n => n.id === 'uploadResult'));

            if (!hasBranchStructure) {
                // 线性排列
                outNodes.forEach((n, idx) => {
                    n.column = idx;
                    n.row = 0;
                });
                rows = [0];
                columns = outNodes.map((_, i) => i);
            } else {
           
                function calculateNodeLayout(nodes) {
                    // 创建节点映射
                    const nodeMap = new Map();
                    nodes.forEach(node => {
                        nodeMap.set(node.id, {
                            ...node,
                            row: 0,
                            column: -1,
                            visited: false
                        });
                    });

                    // 找到起始节点（没有前驱节点的节点）
                    const startNodes = nodes.filter(node => node.previous.length === 0);

                    // 计算最大列数
                    let maxColumn = -1;
                    let maxRow = 0;

                    // 递归计算节点位置
                    function calculatePosition(nodeId, currentRow, currentColumn) {
                        const node = nodeMap.get(nodeId);

                        if (!node || node.visited) {
                            return;
                        }

                        // 标记为已访问
                        node.visited = true;

                        // 设置列位置（取当前列和已有列的最大值+1）
                        node.column = Math.max(node.column, currentColumn + 1);
                        maxColumn = Math.max(maxColumn, node.column);

                        // 设置行位置
                        node.row = currentRow;
                        maxRow = Math.max(maxRow, currentRow);

                        // 处理后续节点
                        const nextNodes = node.next || [];

                        if (nextNodes.length === 0) {
                            // 没有后续节点，结束
                            return;
                        } else if (nextNodes.length === 1) {
                            // 单个后续节点，保持当前行
                            calculatePosition(nextNodes[0], currentRow, node.column);
                        } else {
                            // 多个后续节点，产生分支
                            // 第一个分支保持当前行，其他分支行数递增
                            nextNodes.forEach((nextId, index) => {
                                const nextRow = currentRow + index;
                                calculatePosition(nextId, nextRow, node.column);
                            });
                        }
                    }

                    // 从所有起始节点开始计算
                    startNodes.forEach((startNode, index) => {
                        calculatePosition(startNode.id, index, -1);
                    });

                    // 第二遍遍历：处理合并节点的列位置
                    // 重置访问状态
                    nodeMap.forEach(node => {
                        node.visited = false;
                    });

                    function adjustMergeNodes(nodeId) {
                        const node = nodeMap.get(nodeId);

                        if (!node || node.visited) {
                            return;
                        }

                        node.visited = true;

                        // 处理合并情况（多个前驱指向同一个节点）
                        const previousNodes = node.previous || [];
                        if (previousNodes.length > 1) {
                            // 找到所有前驱节点的最大列数
                            const prevColumns = previousNodes.map(prevId => {
                                const prevNode = nodeMap.get(prevId);
                                return prevNode ? prevNode.column : -1;
                            });
                            const maxPrevColumn = Math.max(...prevColumns);

                            // 当前节点的列数应该是前驱节点最大列数 + 1
                            node.column = Math.max(node.column, maxPrevColumn + 1);
                            maxColumn = Math.max(maxColumn, node.column);

                            // 调整行位置到最小行，实现合并
                            const prevRows = previousNodes.map(prevId => {
                                const prevNode = nodeMap.get(prevId);
                                return prevNode ? prevNode.row : node.row;
                            });
                            const minPrevRow = Math.min(...prevRows);
                            node.row = minPrevRow;
                            maxRow = Math.max(maxRow, minPrevRow);
                        }

                        // 递归处理后续节点
                        const nextNodes = node.next || [];
                        nextNodes.forEach(nextId => {
                            adjustMergeNodes(nextId);
                        });
                    }

                    // 从所有起始节点开始调整合并节点
                    startNodes.forEach(startNode => {
                        adjustMergeNodes(startNode.id);
                    });

                    // 生成行和列的范围数组
                    const rows = Array.from({ length: maxRow + 1 }, (_, i) => i);
                    const columns = Array.from({ length: maxColumn + 1 }, (_, i) => i);
                    
                    // 返回格式化结果
                    return {
                        nodes: nodes.map(node => {
                            const calculatedNode = nodeMap.get(node.id);
                            return {
                                ...node,
                                row: calculatedNode.row,
                                column: calculatedNode.column
                            };
                        }),
                        rows: rows,
                        columns: columns
                    };
                }
                const data = calculateNodeLayout(outNodes)
                rows = data.rows
                columns = data.columns
                outNodes = data.nodes
            }

            // 最终输出，剔除临时字段，保证 row/column 存在
            const finalNodes = outNodes.map(n => ({
                id: n.id,
                label: n.label,
                status: n.status,
                previous: n.previous || [],
                next: n.next || [],
                row: typeof n.row === 'number' ? n.row : 0,
                column: typeof n.column === 'number' ? n.column : 0
            }));
            return { nodes: finalNodes, columns: rows, rows: columns };
        },
        getSearchData(sendData) {
            if (sendData) {
                this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
                if (Object.keys(sendData).length) {
                    this.searchConditionTag.push(sendData)
                }
                this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
                this.getData('search', this.activeTab, this.activeName)
            }
        },
        getEditStatus(record) {
            if (['纯分析', '预付款扣款（纯分析）'].includes(record.projectType)) {
                return ['APPLYING', 'EVALUATING', 'DEFEAT'].includes(record.status);
            } else {
                return ['APPLYING', 'DEFEAT'].includes(record.status);
            }
        },
        getStatus(text, label) {
            let status;
            switch (label) {
                case 'contractAuditStatus':
                    status = 'SUCCESS'
                    break
                case 'contractMailStatus':
                    status = 'MAILED'
                    break
                case 'invoicingStatus':
                    status = 'ALL_INVOICED'
                    break
                case 'receiptStatus':
                    status = 'PAYMENT_RECEIVED'
                    break
                default:
                    break
            }
            if (text[label] === status && text['contractAuditStatus'] !== 'DEFEAT') {
                return 'success'
            } else {
                return ''
            }
        },
        // 合同变更
        complements(row) {
            this.addEditCon = {
                showDialog: true,
                contractSelectDetail: row,
                recordSelectDetail:{},
                mailSelectDetail:{},
                operation: 'change'
            }
        },
        handleCommandContract(command, record) {
            switch (command) {
                case 'record':
                    this.contractAddRecord(record)
                    break;
                case 'complements':
                    this.complements(record)
                    break;
                case 'download':
                    this.download(record)
                    break;
                case 'promotionMail':
                    this.promotionMail(record)
                    break;
                case 'terminateContract':
                    this.terminateApply(record,'','contract')
                    break
                case 'terminateProject':
                    this.terminateApply(record,'','project')
                    break
                case 'signContract':
                    this.signContract(record)
                    break;
                case 'offset':
                    this.offset(record)
                    break;
                default:
                    break;
            }
        },
        handleAdmin(command, record) {
            switch (command) {
                case 'edit':
                    this.adminEdits(record,'adminEdits')
                    break;
                case 'terminateContract':
                    this.terminateApply(record,'admin','contract')
                    break
                case 'terminateProject':
                    this.terminateApply(record, 'admin', 'project')
                    break 
                default:
                    break;
            }
        },
        async offset(row) {
            try {
                if (row['contractOffsetAuditFlag']) {
                    this.$messageUi.error('存在已提交的抵扣申请，请勿重复申请');
                    return;
                }
                const response = await getReceivedAmount(row.id);
                if (response.code !== 200) {
                    this.$messageUi.error('获取已到款金额失败，请重试');
                    return;
                }
                if (Number(response.data) !== Number(row.actualInvoicedAmount)) {
                    this.$messageUi.error('合同已开发票未全部到款，无法申请抵扣');
                    return;
                }
                this.offSet = {
                    showDialog: true,
                    selectDetail: { ...row }
                }
            } catch (error) {
                console.error('Error in offset method:', error);
            }
        },
        signContract(row) {
            if (row) {
                this.signContractInfo = {
                    showDialog: true,
                    selectDetail: [row]
                }
            } else {
                let selectable = this.selectable.filter(item => item.status === 'SUCCESS'
                    && ['FORMAL'].includes(item.contractType)
                    && ['测序分析'].includes(item.projectType)
                    && item['contractRelatedStatus']['receiptStatus'] !== 'PAYMENT_RECEIVED')
                let checkAble = this.selectable.filter(item => item.status !== 'SUCCESS'
                    || !['FORMAL'].includes(item.contractType)
                    || !['测序分析'].includes(item.projectType)
                    || item['contractRelatedStatus']['receiptStatus'] === 'PAYMENT_RECEIVED')
                if (checkAble.length > 0) {
                    let numbers = checkAble.map(item => item.contractNumber).join(',')
                    this.$messageUi.error('合同编号为' + numbers + '的合同暂无法申请签署')
                    return
                }
                if (selectable.length === 0) {
                    this.$messageUi.error('请勾选要申请签署的合同')
                    return
                }
                const map = new Map();
                selectable.forEach(item => {
                    const key = `${item['sales']['uuid']}`;
                    if (!map.has(key)) {
                        map.set(key, {
                            salesName: item['sales']['name'],
                            contractNumbers: []
                        });
                    }
                    map.get(key).contractNumbers.push(item.contractNumber);
                });
                const groupedData = Array.from(map.values());
                if (groupedData.length > 1) {
                    this.$messageUi.error('选择合同的销售不一致，请重新选择')
                } else {
                    this.signContractInfo = {
                        showDialog: true,
                        selectDetail: selectable
                    }
                }
            }
        },
        terminateApply(row,type,flag) {
            if (row.specificProjectType.length === 0) {
                if (['APPLYING', 'DEFEAT'].includes(row.status)) {
                    this.$confirmUi('确定要终止合同吗?', '信息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        // 删除
                        let data = {
                            "id": row.id,
                            "reasonForTermination": '',
                            "contractTerminateFlag": true
                        }
                        let ApiMethod = terminateApply
                        if(type) {
                            ApiMethod = adminTerminate
                        }
                        ApiMethod(data).then(res => {
                            if (res.code === 200) {
                                this.$store.commit('right/setChangeRed', true)
                                this.$messageUi.success('已终止合同!')
                                this.changeActiveTab()
                            }
                        }).catch(err => { })
                    }).catch(() => { })
                } else {
                    this.$prompt('请输入合同终止原因', type ?'确定要终止合同吗?':'确定要申请合同终止吗?', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /.+/,
                        inputErrorMessage: '申请原因不可为空',
                        closeOnClickModal: false
                    }).then(({ value }) => {
                        // 删除
                        let data = {
                            "id": row.id,
                            "reasonForTermination": value,
                            "contractTerminateFlag": true
                        }
                        let ApiMethod = terminateApply
                        if (type) {
                            ApiMethod = adminTerminate
                        }
                        ApiMethod(data).then(res => {
                            if (res.code === 200) {
                                this.$store.commit('right/setChangeRed', true)
                                if(type){
                                    this.$messageUi.success('合同已终止!')
                                }else{
                                    this.$messageUi.success('已申请合同终止!')
                                }
                                this.changeActiveTab()
                            }
                        }).catch(err => { })
                    }).catch(() => { })
                }
            } else {
                this.terminateData = {
                    showDialog: true,
                    selectDetail: { ...row },
                    type: type?'admin':'',
                    flag: flag
                }
            }
        },
        checkArray(arr, key) {
            if (arr.length <= 1) {
                return false;
            }
            const firstValue = arr[0][key]; // 获取第一个元素的指定key的value
            for (let i = 1; i < arr.length; i++) {
                if (arr[i][key] !== firstValue) {
                    return true
                }
            }
            return false;
        },
        contractAddRecord(row) {
            if (row) {
                if (row['contractChangeAuditFlag']) {
                      this.$messageUi.error('该合同存在未完成的变更,暂无法申请开票')
                      return
                }
                if (row['contractTerminateAuditFlag']) {
                    this.$messageUi.error('该合同存在未完成的终止审核,暂无法申请开票')
                    return
                }
                const invoice = row['invoiceRecordDTOs']?.find(item => item.status === 'DEFEAT')
                if (invoice) {
                    this.$confirmUi('该合同存在被驳回的发票申请,是否仍申请新发票?', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '提交新申请',
                        cancelButtonText: '编辑旧申请',
                        type: 'warning'
                    }).then(() => {
                        this.addEditInvoice = {
                            showDialog: true,
                            contractDetails: [row],
                            selectType: {
                                type: 'add',
                            },
                            selectDetail:{}
                        }
                    }).catch(action => {
                        if (action === 'cancel') {
                            let data = {
                                "query#id.EQ": invoice.id
                            }
                            getRecordPage({}, data).then(res => {
                                if (res.code === 200 && res.data.records.length > 0) {
                                    this.addEditInvoice = {
                                        showDialog: true,
                                        contractDetails: [],
                                        selectType: {
                                            type: 'edit',
                                        },
                                        selectDetail: res.data.records[0]
                                    }
                                }
                            }).catch(res => {
                                this.$messageUi.error('获取发票信息失败')
                            })
                        }
                    });
                } else {
                    this.addEditInvoice = {
                        showDialog: true,
                        contractDetails: [row],
                        selectType: {
                            type: 'add',
                        },
                        selectDetail: {}
                    }
                }
            } else {
                // 1. 定义检查规则
                const check = (item) =>
                    Number(item['invoicedAmount']) > 0 &&
                    item.status === 'SUCCESS' &&
                    !item['sourceIntentProjectId'] &&
                    !['CHARGEBACKS', 'DEVELOPMENT', 'ADVANCE_PAYMENT_TRANSFER'].includes(item.contractType) &&
                    !item['contractChangeAuditFlag'] &&
                    !item['contractTerminateAuditFlag'];

                // 2. 防御性获取数据源
                const { selectable: items = [] } = this;
                const selectableArr = Array.isArray(items) ? items : [];

                // 3. 执行拆分
                const result = items.reduce(
                    (acc, item) => {
                        if (check(item)) {
                            acc[0].push(item); // 索引0存放“可操作”项
                        } else {
                            acc[1].push(item); // 索引1存放“不可操作”项
                        }
                        return acc;
                    },
                    [[], []]
                );

                // 4. 获取结果
                const selectable = result[0]; // 符合条件的列表
                const checkAble = result[1];  // 不符合条件的列表

                if (checkAble.length > 0) {
                    let numbers = checkAble.map(item => item.contractNumber).join(',')
                    this.$messageUi.error('合同编号为' + numbers + '的合同暂无法开票或无法合并开票')
                    return
                }
                if (selectable.length === 0) {
                    this.$messageUi.error('请勾选要开票的合同,未通过与可开票金额不大于0的合同无法选择开票')
                    return
                }
                const map = new Map();
                selectable.forEach(item => {
                    // const key = `${item.salesId}-${item.customerContactsId}`;
                    const key = `${item['sales']['uuid']}`;
                    if (!map.has(key)) {
                        map.set(key, {
                            salesName: item['sales']['name'],
                            // companyName: item['customerContacts']['contactName'],
                            contractNumbers: []
                        });
                    }
                    map.get(key).contractNumbers.push(item.contractNumber);
                });
                const groupedData = Array.from(map.values());
                if (groupedData.length > 1) {
                    // if (this.checkArray(groupedData, 'salesName') && this.checkArray(groupedData, 'companyName')) {
                    //   this.$messageUi.error('选择合同的销售与客户联系人均不一致，请重新选择')
                    // } else
                    // if (this.checkArray(groupedData, 'salesName')) {
                    this.$messageUi.error('选择合同的销售不一致，请重新选择')
                    // }
                    //   else if (this.checkArray(groupedData, 'companyName')) {
                    //   this.$messageUi.error('选择合同的客户联系人不一致，请重新选择')
                    // }
                } else {
                    this.addEditInvoice = {
                        showDialog: true,
                        contractDetails: selectable,
                        selectType: {
                            type: 'add',
                        },
                        selectDetail: {}
                    }
                }
            }
        },
        promotionMail(row) {
            if (row) {
                if (Object.keys(row['contractMails'] || {}).length === 0) {
                    this.addEditMail = {
                        showDialog: true,
                        selectType: {
                            type: 'add',
                        },
                        selectDetail: {},
                        contractId: [row]
                    }
                } else {
                    this.$confirmUi('该合同存在被取消的邮寄信息,是否仍申请新邮寄?', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '提交新申请',
                        cancelButtonText: '编辑旧申请',
                        type: 'warning'
                    }).then(() => {
                        this.addEditMail = {
                            showDialog: true,
                            selectType: {
                                type: 'add',
                            },
                            selectDetail: {},
                            contractId: [row]
                        }
                    }).catch(action => {
                        if (action === 'cancel') {
                            let data = {
                                "query#id.EQ": Object.keys(row['contractMails'])[0]
                            }
                            getMailPage({}, data).then(res => {
                                if (res.code === 200 && res.data.records.length > 0) {
                                    this.addEditMail = {
                                        showDialog: true,
                                        selectType: {
                                            type: 'edit',
                                        },
                                        selectDetail: res.data.records[0],
                                        contractId: []
                                    }
                                }
                            }).catch(res => {
                                this.$messageUi.error('获取邮寄信息失败')
                            })
                        }
                    });
                }
            } else {
                let check = (item) => item.status === 'SUCCESS'
                    && (Object.keys(item.contractMails || {}).length === 0 || Object.values(item.contractMails || {}).filter(val => val !== 'CANCELED').length === 0)
                    && !item['contractTerminateAuditFlag']
                    && !item['sourceIntentProjectId']
                    && !['ADVANCE_PAYMENT_TRANSFER', 'CHARGEBACKS', 'DEVELOPMENT'].includes(item.contractType)

                    // 2. 防御性获取数据源
                const { selectable: items = [] } = this;
                const selectableArr = Array.isArray(items) ? items : [];

                // 3. 执行拆分
                const result = items.reduce(
                    (acc, item) => {
                        if (check(item)) {
                            acc[0].push(item); // 索引0存放“可操作”项
                        } else {
                            acc[1].push(item); // 索引1存放“不可操作”项
                        }
                        return acc;
                    },
                    [[], []]
                );

                // 4. 获取结果
                const selectable = result[0]; // 符合条件的列表
                const checkAble = result[1];  // 不符合条件的列表

                if (checkAble.length > 0) {
                    let numbers = checkAble.map(item => item.contractNumber).join(',')
                    this.$messageUi.error('合同编号为' + numbers + '的合同暂无法选择邮寄')
                    return
                }
                if (selectable.length === 0) {
                    this.$messageUi.error('请勾选要邮寄的合同,未通过或已申请邮寄的合同无法选择邮寄')
                    return
                }
                const map = new Map();
                selectable.forEach(item => {
                    const key = `${item.salesId}-${item.customerContactsId}`;
                    if (!map.has(key)) {
                        map.set(key, {
                            salesName: item['sales']['name'],
                            companyName: item['customerContacts']['contactName'],
                            ids: []
                        });
                    }
                    map.get(key).ids.push(item.id);
                });
                const groupedData = Array.from(map.values());
                if (groupedData.length > 1) {
                    if (this.checkArray(groupedData, 'salesName') && this.checkArray(groupedData, 'companyName')) {
                        this.$messageUi.error('选择合同的销售与客户联系人均不一致，请重新选择')
                    } else if (this.checkArray(groupedData, 'salesName')) {
                        this.$messageUi.error('选择合同的销售不一致，请重新选择')
                    } else if (this.checkArray(groupedData, 'companyName')) {
                        this.$messageUi.error('选择合同的客户联系人不一致，请重新选择')
                    }
                } else {
                    this.addEditMail = {
                        showDialog: true,
                        selectType: {
                            type: 'add',
                        },
                        selectDetail: {},
                        contractId: selectable
                    }
                }
            }
        },
        getCheckedBox(col, cols) {
            this.checkedCol = col.filter(item => cols.includes(item.title))
        },
        handleDetails(row) {
            if (this.activeTab === 'contract') {
                this.details.selectDetail = [row]
            } else if (this.activeTab === 'terminate') {
                this.details.selectDetail = [row.data]
            } else {
                this.details.selectDetail = row.sequencingContractDTO
                this.details.info = row
            }
            this.details.showDialog = true
        },
        handleChangeDetails(row) {
            this.changeInfo = {
                showDialog: true,
                selectDetail:row
            }
        },
        close(target, type) {
            if (target === 'addEditCon' || type === 'confirm') {
                this.tableData = []
            }
            // 统一刷新逻辑：addEditCon 有独立的刷新逻辑
            if (target !== 'addEditCon' && type === 'confirm') {
                this.getData('', this.activeTab, this.activeName)
            }
            this.$nextTick(() => {
                switch (target) {
                case 'details':
                    this.details = { showDialog: false, selectDetail: [], info: {} }
                    break
                case 'changeInfo':
                    this.changeInfo = { showDialog: false, selectDetail: {} }
                    break
                case 'flowChart':
                    this.flowChart = { showDialog: false, selectDetail: { nodes: [], edges: [] } }
                    break
                case 'contactInfo':
                    this.contactInfo = { showDialog: false, selectDetail: [] }
                    break
                case 'impairmentInfo':
                    this.impairmentInfo = { showDialog: false, selectDetail: {} }
                    break
                case 'statusInfo':
                    this.statusInfo = { showDialog: false, selectDetail: '' }
                    break
                case 'offSet':
                    this.offSet = { showDialog: false, selectDetail: {} }
                    break
                case 'signContractInfo':
                    this.signContractInfo = { showDialog: false, selectDetail: [] }
                    break
                case 'terminateData':
                    this.terminateData = { showDialog: false, selectDetail: {}, type: '', flag: '' }
                    break
                case 'addEditMail':
                    this.addEditMail = { showDialog: false, selectType: {}, selectDetail: {}, contractId: [] }
                    break
                case 'addEditInvoice':
                    this.addEditInvoice = { showDialog: false, selectType: {}, contractDetails: [], selectDetail: {} }
                    break
                case 'addEditCon':
                    this.addEditCon = {
                        showDialog: false,
                        contractSelectDetail: {},
                        invoiceSelectDetail: {},
                        mailSelectDetail: {},
                        operation: ''
                    }
                    if (type === 'con') {
                        this.getData('', 'draft', 'draft')
                    } else if (type === 'confirm') {
                        this.getData('', 'contract', 'all')
                        this.activeTab = 'contract'
                        this.activeName = 'all'
                        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag
                        this.$refs.wMyTable.selectedRowKeys = this.selectable.map(item => item.id)
                    } else {
                        this.getData('', this.activeTab, this.activeName)
                    }
                    break
                  default:
                    break
                }
            })
        },
        //下载附件
        async handleCommand(command) {
            try {
                let url = `${baseURL}/draft-box/attachment/${command.id}/${command.command}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role") }`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        handleDownloadSign(row) {
            try {
                if (row.annex) {
                    let url = `${baseURL}/contract-sign/download-file/${row.id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                    const elink = document.createElement('a')
                    elink.href = url
                    document.body.appendChild(elink)
                    elink.click()
                    document.body.removeChild(elink);
                } else {
                    getDownloadLink(row.id).then(res => {
                        if (res.code === 200) {
                            const elink = document.createElement('a')
                            elink.href = res.data
                            document.body.appendChild(elink)
                            elink.click()
                            document.body.removeChild(elink);
                        }
                    }).catch(err => { })
                }
            } catch (error) {
                console.log(error);
            }
        },
        async download(row) {
            try {
                let url = `${baseURL}/sequencing-contract/attachment/${row.id}/CONTRACT_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role") }`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        rowSelection(selectedRows, tab) {
            if (tab === 'draft') {
                this.data[tab].children[0].ids = [...this.data[tab].children[0].ids, ...selectedRows.map(item => item.id)].filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item))
            } else {
                this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id))
            }
        },
        getTableSearchSortCon(...args) {
            // 支持多种调用签名：
            // 1. 通过包装器传入 event 数组 + tab + name: (...event) => { getTableSearchSortCon(event, activeTab, activeName) }
            // 2. 直接作为事件处理函数被调用，接收 (searchConditionTag, sortConditionTag)
            let ConditionTag, tab, name
            if (Array.isArray(args[0]) && typeof args[1] === 'string') {
                // 情形 1
                ConditionTag = args[0]
                tab = args[1]
                name = args[2]
            } else {
                // 情形 2 或其它，兼容性回退
                ConditionTag = args[0]
                tab = args[1] || this.activeTab
                name = args[2] || this.activeName
            }

            if (!ConditionTag) {
                return
            }

            const searchTag = ConditionTag[0] || []
            const sortTag = ConditionTag[1] || []

            // 设置全局共享的搜索和排序条件
            this.searchConditionTag = searchTag
            this.sortConditionTag = sortTag
            this.getData('search', tab, name)
        },
        changeActiveTab() {
            this.activeName = this.data[this.activeTab].children[0].name
            // 重置公用字段
            this.searchConditionTag = []
            this.sortConditionTag = []
            this.selectable = []
            this.tableData = []
            this.page = { pageSize: 10, currentNum: 1, total: null }
            for (let item of this.data[this.activeTab].children) {
                if (item.showBadge && item.name !== this.activeName) {
                    this.getTabData(item)
                }
            }
            this.getData('', this.activeTab, this.activeName)
            this.$nextTick(() => {
                this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
                this.$refs.wMyTable.selectedRowKeys = this.selectable.map(item => item.id)
            })
            
        },
        getTabData(item) {
            let params = {
                'page.current': 1,
                'page.size': 1
            };
            let sendData = { ...item['sendData'] };
            let data;
            if (this.activeTab === 'change') {
                data = 'CONTRACT_CHANGES_AUDIT'
            } else if (this.activeTab === 'terminate') {
                data = 'CONTRACT_TERMINATE_AUDIT'
            } else {
                data = ''
            }
            const ApiMethod = this.data[this.activeTab].ApiMethod
            ApiMethod(params, sendData, data).then(res => {
                if (res.code === 200) {
                    item.total = parseInt(res.data.total);
                }
            }).catch(err => {
                console.log(err);
            });
        },
        changeActiveName() {
            // 重置公用字段
            this.searchConditionTag = []
            this.sortConditionTag = []
            this.selectable = []
            this.tableData = []
            this.page = { pageSize: 10, currentNum: 1, total: null }
            this.getData('', this.activeTab, this.activeName)
            this.$nextTick(() => {
                this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
                this.$refs.wMyTable.selectedRowKeys = this.selectable.map(item => item.id)
            })
        },
        getData(type, tab, name) {
            let child = this.data[tab].children.find(item => item.name === name)
            this.loading = true
            let params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize,
            };
            if (type) {
                params['page.current'] = 1;
                params['page.size'] = 10;
            }
            if (this.sortConditionTag.length > 0) {
                params["order"] = this.sortConditionTag.map(sortCondition => {
                    return sortCondition.colName + "." + sortCondition.order;
                }).join(",");
            }
            let sendData = { ...child.sendData };
            if (tab === 'draft') {
                if (!['ADMIN', 'MANAGER'].includes(this.role)) {
                    sendData["query#uuid.LIKE"] = this.userData['personUuids'][0]
                }
            }
            let data;
            if (tab === 'change') {
                data = 'CONTRACT_CHANGES_AUDIT'
            } else if (tab === 'terminate') {
                data = 'CONTRACT_TERMINATE_AUDIT'
            } else {
                data = ''
            }
            if (!this.terminateFlag && tab === 'contract') {
                sendData['query#status.NE'] = 'DERELICT'
            }
            sendData = this.getSearch(sendData, tab);
            let ApiMethod = this.data[tab].ApiMethod
            ApiMethod(params, sendData, data).then(res => {
                this.loading = false
                if (res.code === 200) {
                    if (tab === 'draft') {
                        res.data.records.forEach(item => {
                            try {
                                // 检查 draftContent 是否存在且不为空，避免解析错误
                                if (item.draftContent) {
                                    item.draft = JSON.parse(item.draftContent)
                                    item.draftContract = JSON.parse(item.draftContent).contract
                                    item.draftRecord = JSON.parse(item.draftContent).record
                                    item.draftMail = JSON.parse(item.draftContent).mail
                                } else {
                                    item.draft = {}
                                    item.draftContract = {}
                                    item.draftRecord = {}
                                    item.draftMail = {}
                                }
                            } catch (error) {
                                console.log(error);
                                item.draft = {}
                                item.draftContract = {}
                                item.draftRecord = {}
                                item.draftMail = {}
                            }
                        });
                        this.tableData = res.data.records.sort((a, b) => {
                            const dateA = new Date(a.createTime);
                            const dateB = new Date(b.createTime);
                            return dateB - dateA; // 升序排序
                        });
                    } else if (tab !== 'change') {
                        this.tableData = res.data.records;
                    } else {
                        this.tableData = res.data.records.map(itemA => {
                            return {
                                ...itemA,
                                rawDataInfo: itemA.rawData ? JSON.parse(itemA['rawData']) : {},
                                dataChangeInfo: JSON.parse(itemA['dataChange']),
                            }
                        })
                    }
                    if (this.searchConditionTag.some(condition => condition.key === 'sourceIntentProjectId' && condition.value === '正式合同结余')) {
                        this.tableData = this.tableData.filter(record => record['sourceIntentProjectId']);
                    }
                    this.page.currentNum = parseInt(res.data.current);
                    this.page.pageSize = parseInt(res.data.size);
                    this.page.total = parseInt(res.data.total);
                }
            }).catch(error => {
                this.loading = false
            });
        },
        getSearch(sendData, tab) {
            let data = ['baseCompanyName', 'customerContactsName', 'salesName', 'trusteeContactsName', 'customerCompanyName','initialSalesName']
            
            sendData = { ...sendData }
            
            if (tab === 'draft') {
                if (this.searchConditionTag.length > 0) {
                    sendData["query#draftContent.LIKE"] = this.searchConditionTag[0].value.replace(/[A-Za-z]/g, "")
                }
            } else {
                this.searchConditionTag.forEach(item => {
                    let value = item.value
                    if (item.key === 'contractType') {
                        if (item.value === '预付款') {
                            value = 'PREPAYMENTS'
                        } else if (item.value === '老系统预付款') {
                            value = 'IMPORT_PREPAYMENTS'
                        } else if (item.value === '正式') {
                            value = 'FORMAL'
                        } else if (item.value === '研发') {
                            value = 'DEVELOPMENT'
                        } else if (item.value === '预付款转移') {
                            value = 'ADVANCE_PAYMENT_TRANSFER'
                        } else if (item.value === '团队费用') {
                            value = 'TEAM'
                        } else {
                            value = 'CHARGEBACKS'
                        }
                    } else if (item.key === 'signStatus') {
                        if (item.value === '待审核') {
                            value = 'APPLY'
                        } else if (item.value === '已驳回') {
                            value = 'REJECTED'
                        } else if (item.value === '签署发起成功') {
                            value = 'SIGN_FLOW_INITIATED'
                        } else if (item.value === '甲方已读') {
                            value = 'OPERATOR_READ'
                        } else if (item.value === '签署完成') {
                            value = 'SIGNED'
                        } else if (item.value === '已撤销') {
                            value = 'RETRACTED'
                        } else if (item.value === '已过期') {
                            value = 'EXPIRED'
                        } else if (item.value === '签署发起失败') {
                            value = 'INITIATION_FAILED'
                        } else if (item.value === '拒签') {
                            value = 'VISA_REFUSAL'
                        }
                    } else if (item.key === 'impairmentFlag') {
                        if (item.value === '是') {
                            value = 1
                        } else {
                            value = 0
                        }
                    } else if (['contractNumber', 'dataContractNumber'].includes(item.key)) {
                        value = value.replace(/[A-Za-z]/g, "")
                    } else if (item.key === 'status') {
                        if (item.value === '待审核') {
                            value = 'APPLYING'
                        } else if (item.value === '已通过') {
                            value = 'SUCCESS'
                        } else if (item.value === '已驳回') {
                            value = 'DEFEAT'
                        } else if (item.value === '待评估') {
                            value = 'EVALUATING'
                        } else if (item.value === '已终止') {
                            value = 'DERELICT'
                        } else {
                            value = 'CONTRACT_TO_BE_SUBMITTED'
                        }
                    } else if (item.key === 'rawDataReleaseStatus') {
                        if (item.value === '未释放') {
                            value = 'NOT_RELEASED'
                        } else if (item.value === '部分释放') {
                            value = 'PARTIAL_RELEASE'
                        } else {
                            value = 'ALL_RELEASE'
                        }
                    } else if (item.key === 'invoicingStatus') {
                        if (item.value === '未申请') {
                            value = 'NOT_APPLYING'
                        } else if (item.value === '未开票') {
                            value = 'NOT_INVOICED'
                        } else if (item.value === '部分开票') {
                            value = 'PARTIAL_INVOICING'
                        } else {
                            value = 'ALL_INVOICED'
                        }
                    } else if (item.key === 'returnSampleFlag') {
                        if (item.value === '未返样') {
                            value = false
                        } else {
                            value = true
                        }
                    }
                    if (tab !== 'contract') {
                        if (['contractNumber', 'contractType', 'auditCharge', 'contactName','initialSalesName'].includes(item.key)) {
                            sendData[item.key] = value
                        } else {
                            sendData["query#" + item.key + ".LIKE"] = value
                        }
                    } else {
                        if (data.includes(item.key)) {
                            sendData[item.key] = value
                        } else if (['contractType', 'rawDataReleaseStatus', 'invoicingStatus','returnSampleFlag'].includes(item.key)) {
                            sendData["query#" + item.key + ".EQ"] = value
                            if (['returnSampleFlag'].includes(item.key)) {
                                sendData["query#projectType.IN"] = ['返样/暂存样品','预付款扣款（返样/暂存样品）'].join(',')
                            }
                        } else if (item.key === 'sourceIntentProjectId') {

                        } else if (this.option.map(it => it.value).includes(item.key)) {
                            sendData["query#" + item.key + ".BETWEEN"] = item.value
                        } else {
                            sendData["query#" + item.key + ".LIKE"] = value
                        }
                    }
                })
            }
            return sendData
        },
        //页码的变动
        handlePagePagination(page, tab) {
            this.page.currentNum = page.currentNum
            this.page.pageSize = page.pageSize
            this.getData('', tab, this.activeName);
        },
        handleEdit(row) {
            const type = (row !== undefined && row !== 'undefined') ? 'edit' : 'add'
            this.addEditCon = {
                showDialog: true,
                operation: type,
                contractSelectDetail: row || {},
                invoiceSelectDetail: {},
                mailSelectDetail: {}
            }
        },
        submit(row) {
            this.addEditCon.contractSelectDetail = row
            const invoiceIds = row['invoiceRecordDTOs']?.map(item => item.id)
            if (invoiceIds?.length > 0) {
                let data = {
                    "query#id.IN": invoiceIds.join(',')
                }
                getRecordPage({}, data).then(res => {
                    if (res.code === 200) {
                        this.addEditCon.invoiceSelectDetail = res.data.records[0]
                    }
                }).catch(err => { })
            }
            const mailIds = row['contractMails'] ? Object.keys(row['contractMails']) : []
            if (mailIds?.length > 0) {
                let data = {
                    "query#id.IN": mailIds.join(',')
                }
                getMailPage({}, data).then(res => {
                    if (res.code === 200) {
                        this.addEditCon.mailSelectDetail = res.data.records[0]
                    }
                }).catch(err => { })
            }
            this.addEditCon.operation = 'submit'
            this.addEditCon.showDialog = true
        },
        adminEdits(row,type) {
            this.addEditCon = {
                showDialog: true,
                operation: type,
                contractSelectDetail: row,
                invoiceSelectDetail: {},
                mailSelectDetail: {}
            }
        },
        //删除
        handleDelete(row) {
            let ids = []
            if (row && row.id) {
                ids.push(row.id)
            } else {
                if (this.data['draft'].children[0].ids.length > 0) {
                    ids = this.data['draft'].children[0].ids
                } else {
                    this.$messageUi.error('请勾选要批量删除的数据')
                    return
                }
            }
            this.$confirmUi('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                let param = {
                    "ids": ids.join(',')
                }
                deleteDraft(param).then(res => {
                    if (res.code === 200) {
                        this.$messageUi({
                            type: 'success',
                            message: '删除成功!'
                        })
                        this.data['draft'].children[0].ids = []
                        this.getData('', 'draft', 'draft')
                    }
                }).catch(err => { })
            }).catch(() => { })
        },
        changeShow(type) {
            this.showCard[type] = !this.showCard[type]
        },
    }
}
</script>

<style>
.disabled-status {
    cursor: not-allowed !important;
    filter: grayscale(100%) !important;
    opacity: 0.85;
}

/* 全面禁用 .disabled-status 及其所有子元素的交互（鼠标、触摸、选择等） */
.disabled-status,
.disabled-status * {
    pointer-events: none !important;
    /* 阻止鼠标/触摸交互 */
    user-select: none !important;
    /* 禁止文本选择 */
    -webkit-user-select: none !important;
    -ms-user-select: none !important;
    touch-action: none !important;
    /* 禁止触摸滚动/缩放等 */
    cursor: not-allowed !important;
}

/* 对表单聚焦样式做补偿，防止残留虚线/高亮 */
.disabled-status :focus {
    outline: none !important;
    box-shadow: none !important;
}

/* 确保 a 链接、button 等不可点击且显示不可用样式（兼容某些浏览器/组件） */
.disabled-status a,
.disabled-status button,
.disabled-status input,
.disabled-status textarea,
.disabled-status select,
.disabled-status [role="button"],
.disabled-status [tabindex] {
    pointer-events: none !important;
    cursor: not-allowed !important;
    opacity: 0.85;
}
.status-tag-container {
    display: flex;
    justify-content: center;
    /* 水平居中 */
    align-items: center;
    /* 垂直居中，如果需要 */
    height: 100%;
    /* 确保标签在单元格中垂直居中 */
}

.show_card .el-card__header {
    padding: 9px 10px;
}

.header-border .el-card__header {
    border: 1px #ebeef5 solid;
}

.header-border .el-card__body {
    border: 1px #ebeef5 solid;
    padding: 0 !important;
}

/* 表格样式 */
.tableCss {
    width: 100%;
    border: 1px;
    /* table-layout: fixed; */
    /* 固定列宽 */
    border-collapse: collapse;

    td {
        padding: 5px;
        border-right: none;
        /* 保留右侧竖边框 */
        border-left: 1px solid #e8e8e8;
        /* 保留左侧竖边框 */
        border-top: none;
        /* 去掉上边框 */
        border-bottom: none;
        /* 去掉下边框 */
        /*text-align: center;*/
    }

    th {
        padding-left: 10px;
    }
}

th,


th {
    background-color: #f2f2f2;
    font-weight: normal;
    color: #8a8989;
    border: 1px
}

tr:nth-child(even) {
    border: 1px;
    background-color: #f9f9f9;
}

.el-step.is-horizontal.key1 {
    .el-step__icon.is-text {
        background: #ffffff;
        color: #93ea74;
    }

    .el-step__head {
        border-color: #93ea74;
    }

    .el-step__main {

        .el-step__title,
        .el-step__description {
            color: #93ea74;
        }
    }
}


.ant-table-thead {
    position: sticky !important;
    top: 0 !important;
    background-color: white !important;
    z-index: 99 !important;
    border-top: 1px solid #e8e8e8;
}

.ant-table-thead>tr>th {
    border-top: 1px solid #e8e8e8;
}

.ant-table-body {
    max-height: calc(100vh - 110px - 140px) !important;
    overflow: auto !important;
}

.el-steps.el-steps--horizontal.change {
    .el-step__head.is-success {
        border-color: #f37963;
        /* 修改成功状态的边框颜色 */
        color: #f37963;
        /* 修改成功状态的文字颜色 */
    }

    .el-step__line.is-success {
        background-color: #f37963;
        /* 修改步骤条连接线的成功状态颜色 */
    }
}
</style>
